[
  {
    "identifier": "BP_ADD_EVENT_INFO",
    "source_string": "Add event operator information",
    "translation": "Add event operator information",
    "context": " -> BP_ADD_EVENT_INFO"
  },
  {
    "identifier": "BP_CIRCUIT_LAYOUT_ONLY_LBL",
    "source_string": "Circuits only with layouts",
    "translation": "Circuits only with layouts",
    "context": " -> BP_CIRCUIT_LAYOUT_ONLY_LBL"
  },
  {
    "identifier": "BP_CM_ACTIONS",
    "source_string": "Actions",
    "translation": null,
    "context": " -> BP_CM_ACTIONS"
  },
  {
    "identifier": "BP_CM_ADD_BTN_LBL",
    "source_string": "Add",
    "translation": "Add",
    "context": " -> BP_CM_ADD_BTN_LBL"
  },
  {
    "identifier": "BP_CM_ADD_COVER_IMG",
    "source_string": "Add cover image",
    "translation": "Add cover image",
    "context": " -> BP_CM_ADD_COVER_IMG"
  },
  {
    "identifier": "BP_CM_ADD_MEDIA",
    "source_string": "Add media",
    "translation": "Add media",
    "context": " -> BP_CM_ADD_MEDIA"
  },
  {
    "identifier": "BP_CM_BACK_BTN_LBL",
    "source_string": "Back",
    "translation": "Back",
    "context": " -> BP_CM_BACK_BTN_LBL"
  },
  {
    "identifier": "BP_CM_BROWSE_BTN_LBL",
    "source_string": "Browse",
    "translation": "Browse",
    "context": " -> BP_CM_BROWSE_BTN_LBL"
  },
  {
    "identifier": "BP_CM_CANCEL_BTN_LBL",
    "source_string": "Cancel",
    "translation": "Cancel",
    "context": " -> BP_CM_CANCEL_BTN_LBL"
  },
  {
    "identifier": "BP_CM_ACCESS_DENIED_MSG",
    "source_string": "Access denied",
    "translation": "Access denied",
    "context": " -> BP_CM_ACCESS_DENIED_MSG"
  },
  {
    "identifier": "BP_CM_ACCESS_DENIED_SUB_MSG",
    "source_string": "You are not authorized to access this page. If you want to view this information, please contact your administrator.",
    "translation": "You are not authorized to access this page. If you want to view this information, please contact your administrator.",
    "context": " -> BP_CM_ACCESS_DENIED_SUB_MSG"
  },
  {
    "identifier": "BP_CM_CHARACTERS",
    "source_string": "Characters",
    "translation": "Characters",
    "context": " -> BP_CM_CHARACTERS"
  },
  {
    "identifier": "BP_CM_CLOSE_BTN_LBL",
    "source_string": "Close",
    "translation": "Close",
    "context": " -> BP_CM_CLOSE_BTN_LBL"
  },
  {
    "identifier": "BP_CM_CONFIRM_BTN_LBL",
    "source_string": "Confirm",
    "translation": "Confirm",
    "context": " -> BP_CM_CONFIRM_BTN_LBL"
  },
  {
    "identifier": "BP_CM_CONTINUE_BTN_LBL",
    "source_string": "Continue",
    "translation": "Continue",
    "context": " -> BP_CM_CONTINUE_BTN_LBL"
  },
  {
    "identifier": "BP_CM_CREATED_BY",
    "source_string": "Created by <b>{placeholderName}</b>",
    "translation": "Created by <b>{placeholderName}</b>",
    "context": " -> BP_CM_CREATED_BY"
  },
  {
    "identifier": "BP_CM_CREATED_BY_YOU",
    "source_string": "Created by you",
    "translation": "Created by you",
    "context": " -> BP_CM_CREATED_BY_YOU"
  },
  {
    "identifier": "BP_CM_CREATED_ON",
    "source_string": "Created on",
    "translation": "Created on",
    "context": " -> BP_CM_CREATED_ON"
  },
  {
    "identifier": "BP_CM_DELETE_BTN_LBL",
    "source_string": "Delete",
    "translation": "Delete",
    "context": " -> BP_CM_DELETE_BTN_LBL"
  },
  {
    "identifier": "BP_CM_DESCRIPTION",
    "source_string": "Description",
    "translation": "Description",
    "context": " -> BP_CM_DESCRIPTION"
  },
  {
    "identifier": "BP_CM_DISCARD_BTN_LBL",
    "source_string": "Discard",
    "translation": "Discard",
    "context": " -> BP_CM_DISCARD_BTN_LBL"
  },
  {
    "identifier": "BP_CM_DONE_BTN_LBL",
    "source_string": "Done",
    "translation": "Done",
    "context": " -> BP_CM_DONE_BTN_LBL"
  },
  {
    "identifier": "BP_CM_EDIT_BTN_LBL",
    "source_string": "Edit",
    "translation": "Edit",
    "context": " -> BP_CM_EDIT_BTN_LBL"
  },
  {
    "identifier": "BP_CM_FILE_UPLOAD_SUCCESS",
    "source_string": "File uploaded successfully",
    "translation": "File uploaded successfully",
    "context": " -> BP_CM_FILE_UPLOAD_SUCCESS"
  },
  {
    "identifier": "BP_CM_FOOTER_TXT",
    "source_string": "Mercedes-AMG GmbH. All rights reserved.",
    "translation": "Mercedes-AMG GmbH. All rights reserved.",
    "context": " -> BP_CM_FOOTER_TXT"
  },
  {
    "identifier": "BP_CM_GPX_FILE_LABEL",
    "source_string": "gpx file",
    "translation": "gpx file",
    "context": " -> BP_CM_GPX_FILE_LABEL"
  },
  {
    "identifier": "BP_CM_IMG_MAX_SIZE_MSG",
    "source_string": "Image upload failed. Image size exceeds 15 mb. Please choose a smaller file size.",
    "translation": "Image upload failed. Image size exceeds 15 mb. Please choose a smaller file size.",
    "context": " -> BP_CM_IMG_MAX_SIZE_MSG"
  },
  {
    "identifier": "BP_CM_INVALID_IMAGE_FORMAT_MSG",
    "source_string": "Please upload a file in .jpeg, .jpg or .png format",
    "translation": "Please upload a file in .jpeg, .jpg or .png format",
    "context": " -> BP_CM_INVALID_IMAGE_FORMAT_MSG"
  },
  {
    "identifier": "BP_CM_LOAD_MORE_BTN_LBL",
    "source_string": "Load more",
    "translation": "Load more",
    "context": " -> BP_CM_LOAD_MORE_BTN_LBL"
  },
  {
    "identifier": "BP_CM_NO_BTN_LBL",
    "source_string": "No",
    "translation": "No",
    "context": " -> BP_CM_NO_BTN_LBL"
  },
  {
    "identifier": "BP_CM_PAGE_NOT_FOUND_MSG",
    "source_string": "Sorry, page not found!",
    "translation": "Sorry, page not found!",
    "context": " -> BP_CM_PAGE_NOT_FOUND_MSG"
  },
  {
    "identifier": "BP_CM_PREVIEW",
    "source_string": "Preview",
    "translation": "Preview",
    "context": " -> BP_CM_PREVIEW"
  },
  {
    "identifier": "BP_CM_SAVE_BTN_LBL",
    "source_string": "Save",
    "translation": "Save",
    "context": " -> BP_CM_SAVE_BTN_LBL"
  },
  {
    "identifier": "BP_CM_SELECT_TRACK_LAYOUT",
    "source_string": "Please select circuit to select track layout",
    "translation": "Please select circuit to select track layout",
    "context": " -> BP_CM_SELECT_TRACK_LAYOUT"
  },
  {
    "identifier": "BP_CM_SOMETHING_WENT_WRONG_MSG",
    "source_string": "Something went wrong.",
    "translation": "Something went wrong.",
    "context": " -> BP_CM_SOMETHING_WENT_WRONG_MSG"
  },
  {
    "identifier": "BP_CM_UPDATE_BTN_LBL",
    "source_string": "Update",
    "translation": "Update",
    "context": " -> BP_CM_UPDATE_BTN_LBL"
  },
  {
    "identifier": "BP_CM_UPLOAD_COVER_IMAGE",
    "source_string": "a .jpg .jpeg or .png file to upload circuit cover image",
    "translation": "a .jpg .jpeg or .png file to upload circuit cover image",
    "context": " -> BP_CM_UPLOAD_COVER_IMAGE"
  },
  {
    "identifier": "BP_CM_UPLOAD_GPX_ZIP",
    "source_string": "Please upload a file in .gpx or .zip format",
    "translation": "Please upload a file in .gpx or .zip format",
    "context": " -> BP_CM_UPLOAD_GPX_ZIP"
  },
  {
    "identifier": "BP_CM_UPLOADING_FILE_LBL",
    "source_string": "Uploading your file",
    "translation": "Uploading your file",
    "context": " -> BP_CM_UPLOADING_FILE_LBL"
  },
  {
    "identifier": "BP_CM_VIEW_DETAILS",
    "source_string": "View details",
    "translation": "View details",
    "context": " -> BP_CM_VIEW_DETAILS"
  },
  {
    "identifier": "BP_CM_YES_BTN_LBL",
    "source_string": "Yes",
    "translation": "Yes",
    "context": " -> BP_CM_YES_BTN_LBL"
  },
  {
    "identifier": "BP_DRIVE_EXERCISE_LAPNUMBER_VALIDATION_MAX",
    "source_string": "The number cannot exceed 100.",
    "translation": "The number cannot exceed 100.",
    "context": " -> BP_DRIVE_EXERCISE_LAPNUMBER_VALIDATION_MAX"
  },
  {
    "identifier": "BP_DRIVE_EXERCISE_LAPNUMBER_VALIDATION_MIN",
    "source_string": "The number should be greater than 0.",
    "translation": "The number should be greater than 0.",
    "context": " -> BP_DRIVE_EXERCISE_LAPNUMBER_VALIDATION_MIN"
  },
  {
    "identifier": "BP_DRIVE_EXERCISE_LAPTIME_INFO",
    "source_string": "The lap limit should equal the number of participants in a group, plus an additional lap for the introduction and one for the conclusion if they are included.",
    "translation": "The lap limit should equal the number of participants in a group, plus an additional lap for the introduction and one for the conclusion if they are included.",
    "context": " -> BP_DRIVE_EXERCISE_LAPTIME_INFO"
  },
  {
    "identifier": "BP_DRIVE_EXERCISE_SET_LAPTIME",
    "source_string": "Set lap limit",
    "translation": "Set lap limit",
    "context": " -> BP_DRIVE_EXERCISE_SET_LAPTIME"
  },
  {
    "identifier": "BP_EM_ABOUT_EVENT",
    "source_string": "ABOUT YOUR EVENT",
    "translation": "ABOUT YOUR EVENT",
    "context": " -> BP_EM_ABOUT_EVENT"
  },
  {
    "identifier": "BP_EM_ADD_BTN_LBL",
    "source_string": "Add",
    "translation": "Add",
    "context": " -> BP_EM_ADD_BTN_LBL"
  },
  {
    "identifier": "BP_EM_ADD_COVER_IMAGE",
    "source_string": "to add event logo please",
    "translation": "to add event logo please",
    "context": " -> BP_EM_ADD_COVER_IMAGE"
  },
  {
    "identifier": "BP_EM_ADD_PARTICIPANT",
    "source_string": "Add participant",
    "translation": "Add participant",
    "context": " -> BP_EM_ADD_PARTICIPANT"
  },
  {
    "identifier": "BP_EM_ADD_PARTICIPANTS",
    "source_string": "Add participants",
    "translation": "Add participants",
    "context": " -> BP_EM_ADD_PARTICIPANTS"
  },
  {
    "identifier": "BP_EM_ADD_PENALTY",
    "source_string": "Add penalty",
    "translation": "Add penalty",
    "context": " -> BP_EM_ADD_PENALTY"
  },
  {
    "identifier": "BP_EM_ADD_POINTS",
    "source_string": "Add points",
    "translation": "Add points",
    "context": " -> BP_EM_ADD_POINTS"
  },
  {
    "identifier": "BP_EM_ADD_SCORE",
    "source_string": "Add score",
    "translation": "Add score",
    "context": " -> BP_EM_ADD_SCORE"
  },
  {
    "identifier": "BP_EM_ADD_TIME",
    "source_string": "Add time",
    "translation": "Add time",
    "context": " -> BP_EM_ADD_TIME"
  },
  {
    "identifier": "BP_EM_ADMIN_QR_DOWNLOAD_SUCCESS",
    "source_string": "Admin QR Code downloaded successfully",
    "translation": "Admin QR Code downloaded successfully",
    "context": " -> BP_EM_ADMIN_QR_DOWNLOAD_SUCCESS"
  },
  {
    "identifier": "BP_EM_AEH",
    "source_string": "Add event hashtag",
    "translation": "Add event hashtag",
    "context": " -> BP_EM_AEH"
  },
  {
    "identifier": "BP_EM_All",
    "source_string": "All",
    "translation": "All",
    "context": " -> BP_EM_All"
  },
  {
    "identifier": "BP_EM_ALL_EVENTS",
    "source_string": "All events",
    "translation": "All events",
    "context": " -> BP_EM_ALL_EVENTS"
  },
  {
    "identifier": "BP_EM_ANONYMOUS_PARTICIPANT",
    "source_string": "Anonymous Participant",
    "translation": "Anonymous Participant",
    "context": " -> BP_EM_ANONYMOUS_PARTICIPANT"
  },
  {
    "identifier": "BP_EM_ASCENDING",
    "source_string": "Ascending",
    "translation": "Ascending",
    "context": " -> BP_EM_ASCENDING"
  },
  {
    "identifier": "BP_EM_ASTP",
    "source_string": "Add score to the participants",
    "translation": "Add score to the participants",
    "context": " -> BP_EM_ASTP"
  },
  {
    "identifier": "BP_EM_BEST_RACES",
    "source_string": "Best races",
    "translation": "Best races",
    "context": " -> BP_EM_BEST_RACES"
  },
  {
    "identifier": "BP_EM_BEST_TIME",
    "source_string": "Best time",
    "translation": "Best time",
    "context": " -> BP_EM_BEST_TIME"
  },
  {
    "identifier": "BP_EM_BR_IP",
    "source_string": "In progress",
    "translation": "In progress",
    "context": " -> BP_EM_BR_IP"
  },
  {
    "identifier": "BP_EM_BR_RN",
    "source_string": "Participant Name",
    "translation": "Participant Name",
    "context": " -> BP_EM_BR_RN"
  },
  {
    "identifier": "BP_EM_BROWSE_EVENT",
    "source_string": "Browse events of your business",
    "translation": "Browse events of your business",
    "context": " -> BP_EM_BROWSE_EVENT"
  },
  {
    "identifier": "BP_EM_BTE",
    "source_string": "Back to event",
    "translation": "Back to event",
    "context": " -> BP_EM_BTE"
  },
  {
    "identifier": "BP_EM_CEN",
    "source_string": "Change exercise name",
    "translation": "Change exercise name",
    "context": " -> BP_EM_CEN"
  },
  {
    "identifier": "BP_EM_CHANGE",
    "source_string": "Change",
    "translation": "Change",
    "context": "BP_EM_CHANGE",
    "labels": "en-GB.json, en-en.json, en-US.json, Translations-BP 1.xlsx",
    "max_length": null
  },
  {
    "identifier": "BP_EM_CHANGE_EX_NAME",
    "source_string": "Change exericse name",
    "translation": "Change exericse name",
    "context": " -> BP_EM_CHANGE_EX_NAME"
  },
  {
    "identifier": "BP_EM_CHANGE_IMAGE",
    "source_string": "Change image",
    "translation": "Change image",
    "context": " -> BP_EM_CHANGE_IMAGE"
  },
  {
    "identifier": "BP_EM_CIAM_LINKED",
    "source_string": "Linked",
    "translation": "Linked",
    "context": " -> BP_EM_CIAM_LINKED"
  },
  {
    "identifier": "BP_EM_CIRCUIT_LAYOUT_DETAILS",
    "source_string": "Circuit & layout details",
    "translation": "Circuit & layout details",
    "context": " -> BP_EM_CIRCUIT_LAYOUT_DETAILS"
  },
  {
    "identifier": "BP_EM_CLEAR_PENALTY",
    "source_string": "Clear penalty",
    "translation": "Clear penalty",
    "context": " -> BP_EM_CLEAR_PENALTY"
  },
  {
    "identifier": "BP_EM_CONFIRM_DELETE_EVENT_TITLE",
    "source_string": "Confirm event deletion",
    "translation": "Confirm event deletion",
    "context": " -> BP_EM_CONFIRM_DELETE_EVENT_TITLE"
  },
  {
    "identifier": "BP_EM_CONFIRM_DELETE_EXERCISE_TITLE",
    "source_string": "Confirm exercise delete",
    "translation": "Confirm exercise delete",
    "context": " -> BP_EM_CONFIRM_DELETE_EXERCISE_TITLE"
  },
  {
    "identifier": "BP_EM_CONFIRM_DELETE_PARTICIPANT",
    "source_string": "Are you sure you want to delete this participant?",
    "translation": "Are you sure you want to delete this participant?",
    "context": " -> BP_EM_CONFIRM_DELETE_PARTICIPANT"
  },
  {
    "identifier": "BP_EM_CONFIRM_DELETE_PARTICIPANTS",
    "source_string": "Are you sure you want to delete selected {placeholderParticipants} participants ?",
    "translation": "Are you sure you want to delete selected {placeholderParticipants} participants ?",
    "context": " -> BP_EM_CONFIRM_DELETE_PARTICIPANTS"
  },
  {
    "identifier": "BP_EM_CONSISTANCY",
    "source_string": "Consistancy",
    "translation": "Consistancy",
    "context": " -> BP_EM_CONSISTANCY"
  },
  {
    "identifier": "BP_EM_COPIED_FL_URL",
    "source_string": "Copied full leaderboard URL",
    "translation": "Copied full leaderboard URL",
    "context": " -> BP_EM_COPIED_FL_URL"
  },
  {
    "identifier": "BP_EM_COPIED_LL_URL",
    "source_string": "Copied live leaderboard URL",
    "translation": "Copied live leaderboard URL",
    "context": " -> BP_EM_COPIED_LL_URL"
  },
  {
    "identifier": "BP_EM_CREATE_EVENT",
    "source_string": "Create event",
    "translation": "Create event",
    "context": " -> BP_EM_CREATE_EVENT"
  },
  {
    "identifier": "BP_EM_CREATE_EVENT_LOCATION_SEARCH_PLACEHOLDER",
    "source_string": "Search event location",
    "translation": "Search event location",
    "context": " -> BP_EM_CREATE_EVENT_LOCATION_SEARCH_PLACEHOLDER"
  },
  {
    "identifier": "BP_EM_CREATE_EVENT_LOCATION_SHOW_EVENT_ON_MAP",
    "source_string": "Show event on map",
    "translation": "Show event on map",
    "context": " -> BP_EM_CREATE_EVENT_LOCATION_SHOW_EVENT_ON_MAP"
  },
  {
    "identifier": "BP_EM_CREATE_NEW_EVENT",
    "source_string": "Create new event",
    "translation": "Create new event",
    "context": " -> BP_EM_CREATE_NEW_EVENT"
  },
  {
    "identifier": "BP_EM_CROP_COVERIMG",
    "source_string": "Crop cover image",
    "translation": "Crop cover image",
    "context": " -> BP_EM_CROP_COVERIMG"
  },
  {
    "identifier": "BP_EM_DELERE_EVENT_RACES",
    "source_string": "It is not possible to delete events with races",
    "translation": "It is not possible to delete events with races",
    "context": " -> BP_EM_DELERE_EVENT_RACES"
  },
  {
    "identifier": "BP_EM_DELETE_EVENT",
    "source_string": "Delete event",
    "translation": "Delete event",
    "context": " -> BP_EM_DELETE_EVENT"
  },
  {
    "identifier": "BP_EM_DELETE_IMAGE",
    "source_string": "Delete image",
    "translation": "Delete image",
    "context": " -> BP_EM_DELETE_IMAGE"
  },
  {
    "identifier": "BP_EM_DELETE_PARTICIPANTS",
    "source_string": "Delete selected participants",
    "translation": "Delete selected participants",
    "context": " -> BP_EM_DELETE_PARTICIPANTS"
  },
  {
    "identifier": "BP_EM_DESENDING",
    "source_string": "Descending",
    "translation": "Descending",
    "context": " -> BP_EM_DESENDING"
  },
  {
    "identifier": "BP_EM_DLT_EVENT_CONFIRM_MSG",
    "source_string": "Are you sure you want to delete this event?",
    "translation": "Are you sure you want to delete this event?",
    "context": " -> BP_EM_DLT_EVENT_CONFIRM_MSG"
  },
  {
    "identifier": "BP_EM_DLT_EXERCISE_CONFIRM_MSG",
    "source_string": "Are you sure you want to delete this exercise?",
    "translation": "Are you sure you want to delete this exercise?",
    "context": " -> BP_EM_DLT_EXERCISE_CONFIRM_MSG"
  },
  {
    "identifier": "BP_EM_DLT_RACE_CONFIRM_MSG",
    "source_string": "Are you sure you want to delete this race?",
    "translation": "Are you sure you want to delete this race?",
    "context": " -> BP_EM_DLT_RACE_CONFIRM_MSG"
  },
  {
    "identifier": "BP_EM_DOWNLOAD",
    "source_string": "Download",
    "translation": "Download",
    "context": " -> BP_EM_DOWNLOAD"
  },
  {
    "identifier": "BP_EM_DOWNLOAD_ALL",
    "source_string": "Download all",
    "translation": "Download all",
    "context": " -> BP_EM_DOWNLOAD_ALL"
  },
  {
    "identifier": "BP_EM_DOWNLOAD_EM_EXCEL",
    "source_string": "Download .xsl template",
    "translation": "Download .xsl template",
    "context": " -> BP_EM_DOWNLOAD_EM_EXCEL"
  },
  {
    "identifier": "BP_EM_DOWNLOAD_EXCEL_TEMP",
    "source_string": "Download .xlsx template",
    "translation": "Download .xlsx template",
    "context": " -> BP_EM_DOWNLOAD_EXCEL_TEMP"
  },
  {
    "identifier": "BP_EM_DOWNLOAD_PART_QR",
    "source_string": "Download partcipants QR",
    "translation": "Download partcipants QR",
    "context": " -> BP_EM_DOWNLOAD_PART_QR"
  },
  {
    "identifier": "BP_EM_DOWNLOAD_PART_QR_CODES",
    "source_string": "Download participants QR codes",
    "translation": "Download participants QR codes",
    "context": " -> BP_EM_DOWNLOAD_PART_QR_CODES"
  },
  {
    "identifier": "BP_EM_DOWNLOAD_PARTICIPANTS",
    "source_string": "Download selected participants QR codes",
    "translation": "Download selected participants QR codes",
    "context": " -> BP_EM_DOWNLOAD_PARTICIPANTS"
  },
  {
    "identifier": "BP_EM_DOWNLOAD_QR",
    "source_string": "Download QR",
    "translation": "Download QR",
    "context": " -> BP_EM_DOWNLOAD_QR"
  },
  {
    "identifier": "BP_EM_DOWNLOADADM_QR",
    "source_string": "Download admin QR",
    "translation": "Download admin QR",
    "context": " -> BP_EM_DOWNLOADADM_QR"
  },
  {
    "identifier": "BP_EM_DOWNLOADEMP_EXCEL",
    "source_string": "Download empty excel sheet",
    "translation": "Download empty excel sheet",
    "context": " -> BP_EM_DOWNLOADEMP_EXCEL"
  },
  {
    "identifier": "BP_EM_DRAG_DROP",
    "source_string": "Drag and drop here or",
    "translation": "Drag and drop here or",
    "context": " -> BP_EM_DRAG_DROP"
  },
  {
    "identifier": "BP_EM_DRIFT_ANGLE",
    "source_string": "Average drift angle",
    "translation": "Average drift angle",
    "context": " -> BP_EM_DRIFT_ANGLE"
  },
  {
    "identifier": "BP_EM_DRIFT_AVERAGE_ANGLE",
    "source_string": "Calculate the drift score based on the average drift angle",
    "translation": "Calculate the drift score based on the average drift angle",
    "context": " -> BP_EM_DRIFT_AVERAGE_ANGLE"
  },
  {
    "identifier": "BP_EM_DRIFT_CALCULATION",
    "source_string": "Drift score calculation",
    "translation": "Drift score calculation",
    "context": " -> BP_EM_DRIFT_CALCULATION"
  },
  {
    "identifier": "BP_EM_DRIFT_DISTANCE",
    "source_string": "Percentage drifted distance",
    "translation": "Percentage drifted distance",
    "context": " -> BP_EM_DRIFT_DISTANCE"
  },
  {
    "identifier": "BP_EM_DRIFT_DISTANCE_PERCENTAGE",
    "source_string": "Calculate the drift score based on the percentage of distance drifted",
    "translation": "Calculate the drift score based on the percentage of distance drifted",
    "context": " -> BP_EM_DRIFT_DISTANCE_PERCENTAGE"
  },
  {
    "identifier": "BP_EM_DRIFT_ERROR",
    "source_string": "Invalid input",
    "translation": "Invalid input",
    "context": " -> BP_EM_DRIFT_ERROR"
  },
  {
    "identifier": "BP_EM_DRIFT_FINAL_SCORE",
    "source_string": "Final score",
    "translation": "Final score",
    "context": " -> BP_EM_DRIFT_FINAL_SCORE"
  },
  {
    "identifier": "BP_EM_DRIFT_NON_EDITABLE",
    "source_string": "Drift exercise in progress, changes to settings can't be made till the event is complete.",
    "translation": "Drift exercise in progress, changes to settings can't be made till the event is complete.",
    "context": " -> BP_EM_DRIFT_NON_EDITABLE"
  },
  {
    "identifier": "BP_EM_DRIFT_POINTS",
    "source_string": "Points",
    "translation": "Points",
    "context": " -> BP_EM_DRIFT_POINTS"
  },
  {
    "identifier": "BP_EM_DRIFT_PT",
    "source_string": "pt",
    "translation": "pt",
    "context": " -> BP_EM_DRIFT_PT"
  },
  {
    "identifier": "BP_EM_DRIFT_PTS",
    "source_string": "pts",
    "translation": "pts",
    "context": " -> BP_EM_DRIFT_PTS"
  },
  {
    "identifier": "BP_EM_DRIFT_TOTAL_SCORE",
    "source_string": "Total score",
    "translation": "Total score",
    "context": " -> BP_EM_DRIFT_TOTAL_SCORE"
  },
  {
    "identifier": "BP_EM_DRIFT_VALID_DRIFT_ANGLE",
    "source_string": "Maximum valid drift angle (optional)",
    "translation": "Maximum valid drift angle (optional)",
    "context": " -> BP_EM_DRIFT_VALID_DRIFT_ANGLE"
  },
  {
    "identifier": "BP_EM_DRIVE_VIDEO_HOLD",
    "source_string": "Drive video Upload",
    "translation": "Drive video Upload",
    "context": " -> BP_EM_DRIVE_VIDEO_HOLD"
  },
  {
    "identifier": "BP_EM_EDIT_EVENT",
    "source_string": "Edit this event",
    "translation": "Edit this event",
    "context": " -> BP_EM_EDIT_EVENT"
  },
  {
    "identifier": "BP_EM_EDIT_PARTICIPANT",
    "source_string": "Edit participant",
    "translation": "Edit participant",
    "context": " -> BP_EM_EDIT_PARTICIPANT"
  },
  {
    "identifier": "BP_EM_EFFICIENCY",
    "source_string": "Efficiency",
    "translation": "Efficiency",
    "context": " -> BP_EM_EFFICIENCY"
  },
  {
    "identifier": "BP_EM_EMAIL_ALREADY_EXISTS",
    "source_string": "Provided e-mail already exists",
    "translation": "Provided e-mail already exists",
    "context": " -> BP_EM_EMAIL_ALREADY_EXISTS"
  },
  {
    "identifier": "BP_EM_EMAIL_FAIL",
    "source_string": "Email failed",
    "translation": "Email failed",
    "context": " -> BP_EM_EMAIL_FAIL"
  },
  {
    "identifier": "BP_EM_EMAIL_HOLD",
    "source_string": "Email on hold",
    "translation": "Email on hold",
    "context": " -> BP_EM_EMAIL_HOLD"
  },
  {
    "identifier": "BP_EM_EMAIL_SENT",
    "source_string": "Email sent",
    "translation": "Email sent",
    "context": " -> BP_EM_EMAIL_SENT"
  },
  {
    "identifier": "BP_EM_END_DATE",
    "source_string": "Set end date",
    "translation": "Set end date",
    "context": " -> BP_EM_END_DATE"
  },
  {
    "identifier": "BP_EM_ENTER_EVENT_HASHTAG",
    "source_string": "Enter event hashtag",
    "translation": "Enter event hashtag",
    "context": " -> BP_EM_ENTER_EVENT_HASHTAG"
  },
  {
    "identifier": "BP_EM_ENTER_SHORT_URL",
    "source_string": "Enter short URL",
    "translation": "Enter short URL",
    "context": " -> BP_EM_ENTER_SHORT_URL"
  },
  {
    "identifier": "BP_EM_ERR_LARGEIMG",
    "source_string": "Please upload a file with size less than 15Mb",
    "translation": "Please upload a file with size less than 15Mb",
    "context": " -> BP_EM_ERR_LARGEIMG"
  },
  {
    "identifier": "BP_EM_ERR_SMALLIMG",
    "source_string": "Upload image seems to be too small. Please upload higher quality image and try again",
    "translation": "Upload image seems to be too small. Please upload higher quality image and try again",
    "context": " -> BP_EM_ERR_SMALLIMG"
  },
  {
    "identifier": "BP_EM_ERROR_AUTHORIZATION",
    "source_string": "User is not authorized to access this resource",
    "translation": "User is not authorized to access this resource",
    "context": " -> BP_EM_ERROR_AUTHORIZATION"
  },
  {
    "identifier": "BP_EM_ERROR_DELETE_PARTICIPANT",
    "source_string": "Cannot delete participant. Invalid participant or particpant has done races",
    "translation": "Cannot delete participant. Invalid participant or particpant has done races",
    "context": " -> BP_EM_ERROR_DELETE_PARTICIPANT"
  },
  {
    "identifier": "BP_EM_ERROR_PARTICIPANT_EXIST",
    "source_string": "Participant with ID `participant_id` does not exists",
    "translation": "Participant with ID `participant_id` does not exists",
    "context": " -> BP_EM_ERROR_PARTICIPANT_EXIST"
  },
  {
    "identifier": "BP_EM_EVENT_ESVU",
    "source_string": "You can upload the excel sheet via the upload button, If you need the empty excel sheet template please download via download excel sheet button",
    "translation": "You can upload the excel sheet via the upload button, If you need the empty excel sheet template please download via download excel sheet button",
    "context": " -> BP_EM_EVENT_ESVU"
  },
  {
    "identifier": "BP_EM_EVENT_EXERCISE",
    "source_string": "Event exercise",
    "translation": "Event exercise",
    "context": " -> BP_EM_EVENT_EXERCISE"
  },
  {
    "identifier": "BP_EM_EVENT_HASHTAG",
    "source_string": "Event hashtag",
    "translation": "Event hashtag",
    "context": " -> BP_EM_EVENT_HASHTAG"
  },
  {
    "identifier": "BP_EM_EVENT_LOGO",
    "source_string": "Event logo",
    "translation": "Event logo",
    "context": " -> BP_EM_EVENT_LOGO"
  },
  {
    "identifier": "BP_EM_EVENT_NAME",
    "source_string": "Enter event name",
    "translation": "Enter event name",
    "context": " -> BP_EM_EVENT_NAME"
  },
  {
    "identifier": "BP_EM_EVENT_ND",
    "source_string": "It is not possible to delete events with races.",
    "translation": "It is not possible to delete events with races.",
    "context": " -> BP_EM_EVENT_ND"
  },
  {
    "identifier": "BP_EM_EVENT_PECE",
    "source_string": "Past events cannot be modified",
    "translation": "Past events cannot be modified",
    "context": " -> BP_EM_EVENT_PECE"
  },
  {
    "identifier": "BP_EM_EVENT_TYPES",
    "source_string": "Event types",
    "translation": "Event types",
    "context": " -> BP_EM_EVENT_TYPES"
  },
  {
    "identifier": "BP_EM_EVENTS_TITLE",
    "source_string": "Events",
    "translation": "Events",
    "context": " -> BP_EM_EVENTS_TITLE"
  },
  {
    "identifier": "BP_EM_EXERCISE",
    "source_string": "Exercise",
    "translation": "Exercise",
    "context": " -> BP_EM_EXERCISE"
  },
  {
    "identifier": "BP_EM_EXERCISE_BESTTIME",
    "source_string": "Best time",
    "translation": "Best time",
    "context": " -> BP_EM_EXERCISE_BESTTIME"
  },
  {
    "identifier": "BP_EM_EXERCISE_CONSISTANCY",
    "source_string": "Consistency",
    "translation": "Consistency",
    "context": " -> BP_EM_EXERCISE_CONSISTANCY"
  },
  {
    "identifier": "BP_EM_EXERCISE_DELETED",
    "source_string": "Exercise has been deleted",
    "translation": "Exercise has been deleted",
    "context": " -> BP_EM_EXERCISE_DELETED"
  },
  {
    "identifier": "BP_EM_EXERCISE_EFFICIENCY",
    "source_string": "Efficiency",
    "translation": "Efficiency",
    "context": " -> BP_EM_EXERCISE_EFFICIENCY"
  },
  {
    "identifier": "BP_EM_EXERCISE_ENAE",
    "source_string": "The provided exerciseName already exists!.",
    "translation": "The provided exerciseName already exists!.",
    "context": " -> BP_EM_EXERCISE_ENAE"
  },
  {
    "identifier": "BP_EM_EXERCISE_EXIST",
    "source_string": "The provided exerciseName already exists",
    "translation": "The provided exerciseName already exists",
    "context": " -> BP_EM_EXERCISE_EXIST"
  },
  {
    "identifier": "BP_EM_EXERCISE_FLEADERBOARD",
    "source_string": "Full leaderboard",
    "translation": "Full leaderboard",
    "context": " -> BP_EM_EXERCISE_FLEADERBOARD"
  },
  {
    "identifier": "BP_EM_EXERCISE_LEADERBOARD_DETAILS",
    "source_string": "Exercise & leaderboard details",
    "translation": "Exercise & leaderboard details",
    "context": " -> BP_EM_EXERCISE_LEADERBOARD_DETAILS"
  },
  {
    "identifier": "BP_EM_EXERCISE_ND",
    "source_string": "Exercise not deleted",
    "translation": "Exercise not deleted",
    "context": " -> BP_EM_EXERCISE_ND"
  },
  {
    "identifier": "BP_EM_EXERCISE_NOT_DELETED",
    "source_string": "Exercise not deleted",
    "translation": "Exercise not deleted",
    "context": " -> BP_EM_EXERCISE_NOT_DELETED"
  },
  {
    "identifier": "BP_EM_EXERCISE_OFFROADTAXI",
    "source_string": "Off-road taxi",
    "translation": "Off-road taxi",
    "context": " -> BP_EM_EXERCISE_OFFROADTAXI"
  },
  {
    "identifier": "BP_EM_EXERCISE_PECM",
    "source_string": "Past exercises cannot be updated",
    "translation": "Past exercises cannot be updated",
    "context": " -> BP_EM_EXERCISE_PECM"
  },
  {
    "identifier": "BP_EM_EXERCISE_SCORE",
    "source_string": "Score",
    "translation": "Score",
    "context": " -> BP_EM_EXERCISE_SCORE"
  },
  {
    "identifier": "BP_EM_EXERCISE_UYS",
    "source_string": "Unbox your star",
    "translation": "Unbox your star",
    "context": " -> BP_EM_EXERCISE_UYS"
  },
  {
    "identifier": "BP_EM_FAILED",
    "source_string": "Failed",
    "translation": "Failed",
    "context": " -> BP_EM_FAILED"
  },
  {
    "identifier": "BP_EM_FINAL_TIME",
    "source_string": "Final time",
    "translation": "Final time",
    "context": " -> BP_EM_FINAL_TIME"
  },
  {
    "identifier": "BP_EM_GROUP_BTN_LBL",
    "source_string": "Group",
    "translation": "Group",
    "context": " -> BP_EM_GROUP_BTN_LBL"
  },
  {
    "identifier": "BP_EM_INCOMING_RACES",
    "source_string": "Incoming races",
    "translation": "Incoming races",
    "context": " -> BP_EM_INCOMING_RACES"
  },
  {
    "identifier": "BP_EM_ITEM_DELETED",
    "source_string": "Item has been deleted",
    "translation": "Item has been deleted",
    "context": " -> BP_EM_ITEM_DELETED"
  },
  {
    "identifier": "BP_EM_LANGUAGE",
    "source_string": "Language",
    "translation": "Language",
    "context": " -> BP_EM_LANGUAGE"
  },
  {
    "identifier": "BP_EM_LARGEIMG",
    "source_string": "Upload image is too large. Please upload an image below 15mb and try again",
    "translation": "Upload image is too large. Please upload an image below 15mb and try again",
    "context": " -> BP_EM_LARGEIMG"
  },
  {
    "identifier": "BP_EM_LAST_UPDATED",
    "source_string": "Last updated",
    "translation": "Last updated",
    "context": " -> BP_EM_LAST_UPDATED"
  },
  {
    "identifier": "BP_EM_LEADERBOARD_LINKS",
    "source_string": "Leaderboard links",
    "translation": "Leaderboard links",
    "context": " -> BP_EM_LEADERBOARD_LINKS"
  },
  {
    "identifier": "BP_EM_LEADERBOARD_ORDER",
    "source_string": "Leaderboard order",
    "translation": "Leaderboard order",
    "context": " -> BP_EM_LEADERBOARD_ORDER"
  },
  {
    "identifier": "BP_EM_LIVE",
    "source_string": "Live",
    "translation": "Live",
    "context": " -> BP_EM_LIVE"
  },
  {
    "identifier": "BP_EM_PRIVATE",
    "source_string": "Private Event",
    "translation": "Private Event",
    "context": " -> BP_EM_PRIVATE"
  },
  {
    "identifier": "BP_EM_LIVE_EVENTS",
    "source_string": "Live event",
    "translation": "Live event",
    "context": " -> BP_EM_LIVE_EVENTS"
  },
  {
    "identifier": "BP_EM_LIVE_LEADRBOARD",
    "source_string": "Live leaderboard",
    "translation": "Live leaderboard",
    "context": " -> BP_EM_LIVE_LEADRBOARD"
  },
  {
    "identifier": "BP_EM_LOCAL_LANGUAGE",
    "source_string": "Local language",
    "translation": "Local language",
    "context": " -> BP_EM_LOCAL_LANGUAGE"
  },
  {
    "identifier": "BP_EM_MAIL_TRIGGERED_SUCCESS",
    "source_string": "Mail triggered successfully",
    "translation": "Mail triggered successfully",
    "context": " -> BP_EM_MAIL_TRIGGERED_SUCCESS"
  },
  {
    "identifier": "BP_EM_MANAGE_BR_BD",
    "source_string": "Manage best races and race data",
    "translation": "Manage best races and race data",
    "context": " -> BP_EM_MANAGE_BR_BD"
  },
  {
    "identifier": "BP_EM_MANAGE_BTN_LBL",
    "source_string": "Manage",
    "translation": "Manage",
    "context": " -> BP_EM_MANAGE_BTN_LBL"
  },
  {
    "identifier": "BP_EM_MANAGE_EVENT",
    "source_string": "Manage event",
    "translation": "Manage event",
    "context": " -> BP_EM_MANAGE_EVENT"
  },
  {
    "identifier": "BP_EM_MANAGE_EVENT_RELATED_DETAILS",
    "source_string": "Manage general event related details",
    "translation": "Manage general event related details",
    "context": " -> BP_EM_MANAGE_EVENT_RELATED_DETAILS"
  },
  {
    "identifier": "BP_EM_MANAGE_INCOMING_RACES",
    "source_string": "Manage incoming races",
    "translation": "Manage incoming races",
    "context": " -> BP_EM_MANAGE_INCOMING_RACES"
  },
  {
    "identifier": "BP_EM_MANAGE_PARTICIPANTS",
    "source_string": "Manage participants",
    "translation": "Manage participants",
    "context": " -> BP_EM_MANAGE_PARTICIPANTS"
  },
  {
    "identifier": "BP_EM_MANUALLY_ADD_PART",
    "source_string": "Manually add participants",
    "translation": "Manually add participants",
    "context": " -> BP_EM_MANUALLY_ADD_PART"
  },
  {
    "identifier": "BP_EM_ME_ID_CONNECT",
    "source_string": "Mercedes me ID",
    "translation": "Mercedes me ID",
    "context": " -> BP_EM_ME_ID_CONNECT"
  },
  {
    "identifier": "BP_EM_MEMBERS",
    "source_string": "Members",
    "translation": "Members",
    "context": " -> BP_EM_MEMBERS"
  },
  {
    "identifier": "BP_EM_MINUTES",
    "source_string": "Minutes",
    "translation": "Minutes",
    "context": " -> BP_EM_MINUTES"
  },
  {
    "identifier": "BP_EM_MOBILE_RANKING",
    "source_string": "Mobile ranking (Short version)",
    "translation": "Mobile ranking (Short version)",
    "context": " -> BP_EM_MOBILE_RANKING"
  },
  {
    "identifier": "BP_EM_NAME",
    "source_string": "Name",
    "translation": "Name",
    "context": " -> BP_EM_NAME"
  },
  {
    "identifier": "BP_EM_NAME_AZ",
    "source_string": "Name A-Z",
    "translation": "Name A-Z",
    "context": " -> BP_EM_NAME_AZ"
  },
  {
    "identifier": "BP_EM_NAME_ZA",
    "source_string": "Name Z-A",
    "translation": "Name Z-A",
    "context": " -> BP_EM_NAME_ZA"
  },
  {
    "identifier": "BP_EM_NCR",
    "source_string": "No search results",
    "translation": "No search results",
    "context": " -> BP_EM_NCR"
  },
  {
    "identifier": "BP_EM_NEF",
    "source_string": "No events found",
    "translation": "No events found",
    "context": " -> BP_EM_NEF"
  },
  {
    "identifier": "BP_EM_NEW_OLD",
    "source_string": "New to old",
    "translation": "New to old",
    "context": " -> BP_EM_NEW_OLD"
  },
  {
    "identifier": "BP_EM_NO_ACCESS",
    "source_string": "Access denied",
    "translation": "Access denied",
    "context": " -> BP_EM_NO_ACCESS"
  },
  {
    "identifier": "BP_EM_NO_PARTICIPANTS",
    "source_string": "There are currently no Participants for this event, please add/ </br>upload participants list.",
    "translation": "There are currently no Participants for this event, please add/ </br>upload participants list.",
    "context": " -> BP_EM_NO_PARTICIPANTS"
  },
  {
    "identifier": "BP_EM_NO_RACE_FOUND",
    "source_string": "No race found for this participant",
    "translation": "No race found for this participant",
    "context": " -> BP_EM_NO_RACE_FOUND"
  },
  {
    "identifier": "BP_EM_NPF",
    "source_string": "No participants found",
    "translation": "No participants found",
    "context": " -> BP_EM_NPF"
  },
  {
    "identifier": "BP_EM_OLD_NEW",
    "source_string": "Old to new",
    "translation": "Old to new",
    "context": " -> BP_EM_OLD_NEW"
  },
  {
    "identifier": "BP_EM_OPERATOR_EMAIL",
    "source_string": "Operator e-mail",
    "translation": "Operator e-mail",
    "context": " -> BP_EM_OPERATOR_EMAIL"
  },
  {
    "identifier": "BP_EM_OPERATOR_NAME",
    "source_string": "Operator name",
    "translation": "Operator name",
    "context": " -> BP_EM_OPERATOR_NAME"
  },
  {
    "identifier": "BP_EM_OPERATOR_PH",
    "source_string": "Operator phone number",
    "translation": "Operator phone number",
    "context": " -> BP_EM_OPERATOR_PH"
  },
  {
    "identifier": "BP_EM_OPERATOR_TEXT",
    "source_string": "Operator text",
    "translation": "Operator text",
    "context": " -> BP_EM_OPERATOR_TEXT"
  },
  {
    "identifier": "BP_EM_OR",
    "source_string": "OR",
    "translation": "OR",
    "context": " -> BP_EM_OR"
  },
  {
    "identifier": "BP_EM_PARTICIPANT",
    "source_string": "Participant",
    "translation": "Participant",
    "context": " -> BP_EM_PARTICIPANT"
  },
  {
    "identifier": "BP_EM_PARTICIPANT_ADDED_SUCCESS",
    "source_string": "Participant added successfully",
    "translation": "Participant added successfully",
    "context": " -> BP_EM_PARTICIPANT_ADDED_SUCCESS"
  },
  {
    "identifier": "BP_EM_PARTICIPANT_AED",
    "source_string": "Add, edit and download information related to event participants",
    "translation": "Add, edit and download information related to event participants",
    "context": " -> BP_EM_PARTICIPANT_AED"
  },
  {
    "identifier": "BP_EM_PARTICIPANT_DELETED_SUCCESS",
    "source_string": "Participant has been deleted successfully",
    "translation": "Participant has been deleted successfully",
    "context": " -> BP_EM_PARTICIPANT_DELETED_SUCCESS"
  },
  {
    "identifier": "BP_EM_PARTICIPANT_EAE",
    "source_string": "Provided e-mail already exists",
    "translation": "Provided e-mail already exists",
    "context": " -> BP_EM_PARTICIPANT_EAE"
  },
  {
    "identifier": "BP_EM_PARTICIPANT_GROUPS",
    "source_string": "Groups",
    "translation": "Groups",
    "context": " -> BP_EM_PARTICIPANT_GROUPS"
  },
  {
    "identifier": "BP_EM_PARTICIPANT_HDR",
    "source_string": "Cannot delete participant. Invalid participant or particpant has done races",
    "translation": "Cannot delete participant. Invalid participant or particpant has done races",
    "context": " -> BP_EM_PARTICIPANT_HDR"
  },
  {
    "identifier": "BP_EM_PARTICIPANT_LIST_UPDATED_SUCCESS",
    "source_string": "Participant List successfully Updated",
    "translation": "Participant List successfully Updated",
    "context": " -> BP_EM_PARTICIPANT_LIST_UPDATED_SUCCESS"
  },
  {
    "identifier": "BP_EM_PARTICIPANT_PDE",
    "source_string": "Participant with participantId `participant_id` does not exists",
    "translation": "Participant with participantId `participant_id` does not exists",
    "context": " -> BP_EM_PARTICIPANT_PDE"
  },
  {
    "identifier": "BP_EM_PARTICIPANT_UPDATED_SUCCESS",
    "source_string": "Participant updated successfully",
    "translation": "Participant updated successfully",
    "context": " -> BP_EM_PARTICIPANT_UPDATED_SUCCESS"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS",
    "source_string": "Participants",
    "translation": "Participants",
    "context": " -> BP_EM_PARTICIPANTS"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS_DELETED_SUCCESS",
    "source_string": "Participants has been deleted successfully",
    "translation": "Participants has been deleted successfully",
    "context": " -> BP_EM_PARTICIPANTS_DELETED_SUCCESS"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS_ENTER_EMAIL",
    "source_string": "Email",
    "translation": "Email",
    "context": " -> BP_EM_PARTICIPANTS_ENTER_EMAIL"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS_ENTER_FNAME",
    "source_string": "Enter first name",
    "translation": "Enter first name",
    "context": " -> BP_EM_PARTICIPANTS_ENTER_FNAME"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS_ENTER_LNAME",
    "source_string": "Enter last name",
    "translation": "Enter last name",
    "context": " -> BP_EM_PARTICIPANTS_ENTER_LNAME"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS_FIRST_NAME",
    "source_string": "First name",
    "translation": "First name",
    "context": " -> BP_EM_PARTICIPANTS_FIRST_NAME"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS_FORMAT_ERROR",
    "source_string": "Participants format error",
    "translation": "Participants format error",
    "context": " -> BP_EM_PARTICIPANTS_FORMAT_ERROR"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS_LAST_NAME",
    "source_string": "Last name",
    "translation": "Last name",
    "context": " -> BP_EM_PARTICIPANTS_LAST_NAME"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS_NOT_AVAILABLE",
    "source_string": "No participants available",
    "translation": "No participants available",
    "context": " -> BP_EM_PARTICIPANTS_NOT_AVAILABLE"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS_REFRESH",
    "source_string": "Refresh",
    "translation": "Refresh",
    "context": " -> BP_EM_PARTICIPANTS_REFRESH"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS_SCREEN_SUBTITLE",
    "source_string": "Add or manage participants for the event",
    "translation": "Add or manage participants for the event",
    "context": " -> BP_EM_PARTICIPANTS_SCREEN_SUBTITLE"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS_SEARCH_PLACEHOLDER",
    "source_string": "Type participant name, email etc.",
    "translation": "Type participant name, email etc.",
    "context": " -> BP_EM_PARTICIPANTS_SEARCH_PLACEHOLDER"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS_SLNO",
    "source_string": "S.No.",
    "translation": "S.No.",
    "context": " -> BP_EM_PARTICIPANTS_SLNO"
  },
  {
    "identifier": "BP_EM_PARTICIPANTS_SNO",
    "source_string": "S.No.",
    "translation": "S.No.",
    "context": " -> BP_EM_PARTICIPANTS_SNO"
  },
  {
    "identifier": "BP_EM_PAST_EVENT_MODIFY",
    "source_string": "Past events cannot be modified",
    "translation": "Past events cannot be modified",
    "context": " -> BP_EM_PAST_EVENT_MODIFY"
  },
  {
    "identifier": "BP_EM_PAST_EXERCISE_UPDATE",
    "source_string": "Past exercises cannot be updated",
    "translation": "Past exercises cannot be updated",
    "context": " -> BP_EM_PAST_EXERCISE_UPDATE"
  },
  {
    "identifier": "BP_EM_PNF",
    "source_string": "User is not authorized to access this resource",
    "translation": "User is not authorized to access this resource",
    "context": " -> BP_EM_PNF"
  },
  {
    "identifier": "BP_EM_POINTS_VALUE",
    "source_string": "Points value",
    "translation": "Points value",
    "context": " -> BP_EM_POINTS_VALUE"
  },
  {
    "identifier": "BP_EM_PSEE",
    "source_string": "Please select the exercise to the event",
    "translation": "Please select the exercise to the event",
    "context": " -> BP_EM_PSEE"
  },
  {
    "identifier": "BP_EM_QR_CODES",
    "source_string": "QR Codes",
    "translation": "QR Codes",
    "context": " -> BP_EM_QR_CODES"
  },
  {
    "identifier": "BP_EM_RACE_DATA_UPLOAD",
    "source_string": "Race data uploaded",
    "translation": "Race data uploaded",
    "context": " -> BP_EM_RACE_DATA_UPLOAD"
  },
  {
    "identifier": "BP_EM_RACE_DATA_UPLOAD_FAIL",
    "source_string": "Race data upload failed",
    "translation": "Race data upload failed",
    "context": " -> BP_EM_RACE_DATA_UPLOAD_FAIL"
  },
  {
    "identifier": "BP_EM_RACE_DATA_UPLOAD_HOLD",
    "source_string": "Race data upload on hold",
    "translation": "Race data upload on hold",
    "context": " -> BP_EM_RACE_DATA_UPLOAD_HOLD"
  },
  {
    "identifier": "BP_EM_RACE_NF",
    "source_string": "Race not found",
    "translation": "Race not found",
    "context": " -> BP_EM_RACE_NF"
  },
  {
    "identifier": "BP_EM_RACE_READY",
    "source_string": "Ready",
    "translation": "Ready",
    "context": " -> BP_EM_RACE_READY"
  },
  {
    "identifier": "BP_EM_RACE_VIDEO_FAIL",
    "source_string": "Race video upload failed",
    "translation": "Race video upload failed",
    "context": " -> BP_EM_RACE_VIDEO_FAIL"
  },
  {
    "identifier": "BP_EM_RACE_VIDEO_HOLD",
    "source_string": "Race video upload on hold",
    "translation": "Race video upload on hold",
    "context": " -> BP_EM_RACE_VIDEO_HOLD"
  },
  {
    "identifier": "BP_EM_RACE_VIDEO_UPLOAD",
    "source_string": "Race video uploaded",
    "translation": "Race video uploaded",
    "context": " -> BP_EM_RACE_VIDEO_UPLOAD"
  },
  {
    "identifier": "BP_EM_RACER_NAME",
    "source_string": "Participant name",
    "translation": "Participant name",
    "context": " -> BP_EM_RACER_NAME"
  },
  {
    "identifier": "BP_EM_RACES_JUST_NOW",
    "source_string": "Just now",
    "translation": "Just now",
    "context": " -> BP_EM_RACES_JUST_NOW"
  },
  {
    "identifier": "BP_EM_RACES_MIN_AGO",
    "source_string": "{placeholderTime} min ago",
    "translation": "{placeholderTime} min ago",
    "context": " -> BP_EM_RACES_MIN_AGO"
  },
  {
    "identifier": "BP_EM_RACES_UPDATED",
    "source_string": "Races updated",
    "translation": "Races updated",
    "context": " -> BP_EM_RACES_UPDATED"
  },
  {
    "identifier": "BP_EM_RACES_YESTERDAY",
    "source_string": "Yesterday",
    "translation": "Yesterday",
    "context": " -> BP_EM_RACES_YESTERDAY"
  },
  {
    "identifier": "BP_EM_RANK",
    "source_string": "Rank",
    "translation": "Rank",
    "context": " -> BP_EM_RANK"
  },
  {
    "identifier": "BP_EM_RECORDING",
    "source_string": "Recording",
    "translation": "Recording",
    "context": " -> BP_EM_RECORDING"
  },
  {
    "identifier": "BP_EM_REDIRECTING_NEXT_STEP",
    "source_string": "Redirecting you to the next step",
    "translation": "Redirecting you to the next step",
    "context": " -> BP_EM_REDIRECTING_NEXT_STEP"
  },
  {
    "identifier": "BP_EM_REMOVE_EXERCISE",
    "source_string": "Remove exercise",
    "translation": "Remove exercise",
    "context": " -> BP_EM_REMOVE_EXERCISE"
  },
  {
    "identifier": "BP_EM_RENAME_EXERCISE",
    "source_string": "Rename exercise",
    "translation": "Rename exercise",
    "context": " -> BP_EM_RENAME_EXERCISE"
  },
  {
    "identifier": "BP_EM_RESEND_EMAIL",
    "source_string": "Resend email",
    "translation": "Resend email",
    "context": " -> BP_EM_RESEND_EMAIL"
  },
  {
    "identifier": "BP_EM_SC_ISM",
    "source_string": "Initial Score Mismatch",
    "translation": "Initial Score Mismatch",
    "context": " -> BP_EM_SC_ISM"
  },
  {
    "identifier": "BP_EM_SCORE",
    "source_string": "Score",
    "translation": "Score",
    "context": " -> BP_EM_SCORE"
  },
  {
    "identifier": "BP_EM_SCORE_ADDED_SUCCESSFULLY",
    "source_string": "Score added successfully",
    "translation": "Score added successfully",
    "context": " -> BP_EM_SCORE_ADDED_SUCCESSFULLY"
  },
  {
    "identifier": "BP_EM_SCORE_TYPE",
    "source_string": "Score type",
    "translation": "Score type",
    "context": " -> BP_EM_SCORE_TYPE"
  },
  {
    "identifier": "BP_EM_SCORE_TYPE_POINTS",
    "source_string": "Points",
    "translation": "Points",
    "context": " -> BP_EM_SCORE_TYPE_POINTS"
  },
  {
    "identifier": "BP_EM_SCORE_TYPE_TIME",
    "source_string": "Time",
    "translation": "Time",
    "context": " -> BP_EM_SCORE_TYPE_TIME"
  },
  {
    "identifier": "BP_EM_SEARCH_CIRCUIT",
    "source_string": "Search for circuit",
    "translation": "Search for circuit",
    "context": " -> BP_EM_SEARCH_CIRCUIT"
  },
  {
    "identifier": "BP_EM_SEARCH_EVENTS",
    "source_string": "Search events",
    "translation": "Search events",
    "context": " -> BP_EM_SEARCH_EVENTS"
  },
  {
    "identifier": "BP_EM_SEARCH_HERE",
    "source_string": "Search here",
    "translation": "Search here",
    "context": " -> BP_EM_SEARCH_HERE"
  },
  {
    "identifier": "BP_EM_SEARCH_PART_NAME",
    "source_string": "Search particpant name, email etc",
    "translation": "Search particpant name, email etc",
    "context": " -> BP_EM_SEARCH_PART_NAME"
  },
  {
    "identifier": "BP_EM_SEARCH_PARTICIPANT_NAME",
    "source_string": "Search by participants name",
    "translation": "Search by participants name",
    "context": " -> BP_EM_SEARCH_PARTICIPANT_NAME"
  },
  {
    "identifier": "BP_EM_SEARCH_RACER",
    "source_string": "Search by participant name",
    "translation": "Search by participant name",
    "context": " -> BP_EM_SEARCH_RACER"
  },
  {
    "identifier": "BP_EM_SEARCH_RESULTS",
    "source_string": "No search results for",
    "translation": "No search results for",
    "context": " -> BP_EM_SEARCH_RESULTS"
  },
  {
    "identifier": "BP_EM_SECONDS",
    "source_string": "Seconds",
    "translation": "Seconds",
    "context": " -> BP_EM_SECONDS"
  },
  {
    "identifier": "BP_EM_SELECT",
    "source_string": "Select",
    "translation": "Select",
    "context": " -> BP_EM_SELECT"
  },
  {
    "identifier": "BP_EM_SELECT_EVENT_EXERCISES",
    "source_string": "Select event exercises",
    "translation": "Select event exercises",
    "context": " -> BP_EM_SELECT_EVENT_EXERCISES"
  },
  {
    "identifier": "BP_EM_SELEXERCISE",
    "source_string": "Select event exercises",
    "translation": "Select event exercises",
    "context": " -> BP_EM_SELEXERCISE"
  },
  {
    "identifier": "BP_EM_SET_EXERCISE_LEADERBOARD",
    "source_string": "Set your exercises for the event here.",
    "translation": "Set your exercises for the event here.",
    "context": " -> BP_EM_SET_EXERCISE_LEADERBOARD"
  },
  {
    "identifier": "BP_EM_SHOW_ON_MAP_TOOLTIP",
    "source_string": "Please select the location first",
    "translation": "Please select the location first",
    "context": " -> BP_EM_SHOW_ON_MAP_TOOLTIP"
  },
  {
    "identifier": "BP_EM_SHOW_ON_MAP_TOOLTIP_EDIT_MODE",
    "source_string": "Show events on map can not be edited",
    "translation": "Show events on map can not be edited",
    "context": " -> BP_EM_SHOW_ON_MAP_TOOLTIP_EDIT_MODE"
  },
  {
    "identifier": "BP_EM_SORT_BY",
    "source_string": "Sort by",
    "translation": "Sort by",
    "context": " -> BP_EM_SORT_BY"
  },
  {
    "identifier": "BP_EM_START_DATE",
    "source_string": "Set start date",
    "translation": "Set start date",
    "context": " -> BP_EM_START_DATE"
  },
  {
    "identifier": "BP_EM_STATUS",
    "source_string": "Status",
    "translation": "Status",
    "context": " -> BP_EM_STATUS"
  },
  {
    "identifier": "BP_EM_SUBMIT_BTN_LBL",
    "source_string": "Submit",
    "translation": "Submit",
    "context": " -> BP_EM_SUBMIT_BTN_LBL"
  },
  {
    "identifier": "BP_EM_TIME_CLOCKED",
    "source_string": "Time clocked",
    "translation": "Time clocked",
    "context": " -> BP_EM_TIME_CLOCKED"
  },
  {
    "identifier": "BP_EM_TP",
    "source_string": "Total points",
    "translation": "Total points",
    "context": " -> BP_EM_TP"
  },
  {
    "identifier": "BP_EM_TT",
    "source_string": "Total time",
    "translation": "Total time",
    "context": " -> BP_EM_TT"
  },
  {
    "identifier": "BP_EM_UNDO",
    "source_string": "Undo",
    "translation": "Undo",
    "context": " -> BP_EM_UNDO"
  },
  {
    "identifier": "BP_EM_UPDATE_POINTS",
    "source_string": "Update points",
    "translation": "Update points",
    "context": " -> BP_EM_UPDATE_POINTS"
  },
  {
    "identifier": "BP_EM_UPDATE_SCORE",
    "source_string": "Update score",
    "translation": "Update score",
    "context": " -> BP_EM_UPDATE_SCORE"
  },
  {
    "identifier": "BP_EM_UPDATE_TIME",
    "source_string": "Update time",
    "translation": "Update time",
    "context": " -> BP_EM_UPDATE_TIME"
  },
  {
    "identifier": "BP_EM_UPLOAD",
    "source_string": "Upload",
    "translation": "Upload",
    "context": " -> BP_EM_UPLOAD"
  },
  {
    "identifier": "BP_EM_UPLOAD_COMPLETE",
    "source_string": "Upload complete",
    "translation": "Upload complete",
    "context": " -> BP_EM_UPLOAD_COMPLETE"
  },
  {
    "identifier": "BP_EM_UPLOAD_EXCEL",
    "source_string": "You can upload the excel sheet via the upload button, If you need the empty excel sheet template please download via download excel sheet button",
    "translation": "You can upload the excel sheet via the upload button, If you need the empty excel sheet template please download via download excel sheet button",
    "context": " -> BP_EM_UPLOAD_EXCEL"
  },
  {
    "identifier": "BP_EM_UPLOAD_PART_LIST",
    "source_string": "upload participants list.",
    "translation": "upload participants list.",
    "context": " -> BP_EM_UPLOAD_PART_LIST"
  },
  {
    "identifier": "BP_EM_UPLOAD_PARTICIPANTS",
    "source_string": "Upload participants",
    "translation": "Upload participants",
    "context": " -> BP_EM_UPLOAD_PARTICIPANTS"
  },
  {
    "identifier": "BP_EM_UYS_TEMPLATE",
    "source_string": "Choose Template",
    "translation": "Choose Template",
    "context": " -> BP_EM_UYS_TEMPLATE"
  },
  {
    "identifier": "BP_EM_VALID_EMAIL",
    "source_string": "Please enter valid email",
    "translation": "Please enter valid email",
    "context": " -> BP_EM_VALID_EMAIL"
  },
  {
    "identifier": "BP_EM_VALID_FNAME",
    "source_string": "Please enter valid first name",
    "translation": "Please enter valid first name",
    "context": " -> BP_EM_VALID_FNAME"
  },
  {
    "identifier": "BP_EM_VALID_LNAME",
    "source_string": "Please enter valid last name",
    "translation": "Please enter valid last name",
    "context": " -> BP_EM_VALID_LNAME"
  },
  {
    "identifier": "BP_LANG_DE",
    "source_string": "German",
    "translation": "German",
    "context": " -> BP_LANG_DE"
  },
  {
    "identifier": "BP_LANG_ENG",
    "source_string": "English",
    "translation": "English",
    "context": " -> BP_LANG_ENG"
  },
  {
    "identifier": "BP_LM_ADD_DEST_LCN_MSG_NEW",
    "source_string": "Search or manually drop a pin to locate your destination.",
    "translation": "Search or manually drop a pin to locate your destination.",
    "context": " -> BP_LM_ADD_DEST_LCN_MSG_NEW"
  },
  {
    "identifier": "BP_LM_ADD_DESTINATION_LBL",
    "source_string": "Set as destination",
    "translation": "Set as destination",
    "context": " -> BP_LM_ADD_DESTINATION_LBL"
  },
  {
    "identifier": "BP_LM_ADD_DETAILS_BTN_LBL",
    "source_string": "Add details",
    "translation": "Add details",
    "context": " -> BP_LM_ADD_DETAILS_BTN_LBL"
  },
  {
    "identifier": "BP_LM_ADD_DSTN_NEW",
    "source_string": "Enter destination",
    "translation": "Enter destination",
    "context": " -> BP_LM_ADD_DSTN_NEW"
  },
  {
    "identifier": "BP_LM_ADD_INSDR_NEW",
    "source_string": "Search or manually drop a pin to add your insider spot.",
    "translation": "Search or manually drop a pin to add your insider spot.",
    "context": " -> BP_LM_ADD_INSDR_NEW"
  },
  {
    "identifier": "BP_LM_ADD_INSDR_PT",
    "source_string": "Atleast one insider spot is required to generate a tour",
    "translation": "Atleast one insider spot is required to generate a tour",
    "context": " -> BP_LM_ADD_INSDR_PT"
  },
  {
    "identifier": "BP_LM_ADD_INSDR_SPT_NEW",
    "source_string": "Add insider spot",
    "translation": "Add insider spot",
    "context": " -> BP_LM_ADD_INSDR_SPT_NEW"
  },
  {
    "identifier": "BP_LM_ADD_NEW_CIRCUIT",
    "source_string": "Add a New Circuit",
    "translation": "Add a New Circuit",
    "context": " -> BP_LM_ADD_NEW_CIRCUIT"
  },
  {
    "identifier": "BP_LM_ADD_START_BTN_LBL",
    "source_string": "Set as start",
    "translation": "Set as start",
    "context": " -> BP_LM_ADD_START_BTN_LBL"
  },
  {
    "identifier": "BP_LM_ADD_STRT_LCN_MSG_NEW",
    "source_string": "Search or manually drop a pin to locate your start.",
    "translation": "Search or manually drop a pin to locate your start.",
    "context": " -> BP_LM_ADD_STRT_LCN_MSG_NEW"
  },
  {
    "identifier": "BP_LM_ADD_STRT_MSG_NEW",
    "source_string": "Enter start",
    "translation": "Enter start",
    "context": " -> BP_LM_ADD_STRT_MSG_NEW"
  },
  {
    "identifier": "BP_LM_ADDED_TOUR_LBL",
    "source_string": "Added to tour",
    "translation": "Added to tour",
    "context": " -> BP_LM_ADDED_TOUR_LBL"
  },
  {
    "identifier": "BP_LM_ADDING_LAYOUT_MSG",
    "source_string": "Adding your track layout, please wait this might take a few seconds.",
    "translation": "Adding your track layout, please wait this might take a few seconds.",
    "context": " -> BP_LM_ADDING_LAYOUT_MSG"
  },
  {
    "identifier": "BP_LM_ADDRESS",
    "source_string": "Address",
    "translation": "Address",
    "context": " -> BP_LM_ADDRESS"
  },
  {
    "identifier": "BP_LM_ADDRESS_NOT_FOUND",
    "source_string": "Address Not found for given lattitude and longitude",
    "translation": "Address Not found for given lattitude and longitude",
    "context": " -> BP_LM_ADDRESS_NOT_FOUND"
  },
  {
    "identifier": "BP_LM_ALERT",
    "source_string": "Alert",
    "translation": "Alert",
    "context": " -> BP_LM_ALERT"
  },
  {
    "identifier": "BP_LM_ALLOWED_MEDIA_EXTENSION_MSG",
    "source_string": "Please upload a file in .jpeg, .jpg, .png , .gif or .mp4format",
    "translation": "Please upload a file in .jpeg, .jpg, .png , .gif or .mp4format",
    "context": " -> BP_LM_ALLOWED_MEDIA_EXTENSION_MSG"
  },
  {
    "identifier": "BP_LM_AMG_INFO_MSG",
    "source_string": "This location will be tagged and saved to the AMG database if description and media has been added to this location.",
    "translation": "This location will be tagged and saved to the AMG database if description and media has been added to this location.",
    "context": " -> BP_LM_AMG_INFO_MSG"
  },
  {
    "identifier": "BP_LM_BACK_BTN_LBL",
    "source_string": "Back",
    "translation": "Back",
    "context": " -> BP_LM_BACK_BTN_LBL"
  },
  {
    "identifier": "BP_LM_BACK_TO_LOCATIONS_BTN_LBL",
    "source_string": "Back to locations",
    "translation": "Back to locations",
    "context": " -> BP_LM_BACK_TO_LOCATIONS_BTN_LBL"
  },
  {
    "identifier": "BP_LM_BROWSE_LOCATIONS_MSG",
    "source_string": "Browse through the circuits and offroad tracks anywhere around the world.",
    "translation": "Browse through the circuits and offroad tracks anywhere around the world.",
    "context": " -> BP_LM_BROWSE_LOCATIONS_MSG"
  },
  {
    "identifier": "BP_LM_CANCEL_EDITING_CARD_DTLS",
    "source_string": "Unsaved changes",
    "translation": "Unsaved changes",
    "context": " -> BP_LM_CANCEL_EDITING_CARD_DTLS"
  },
  {
    "identifier": "BP_LM_CANCEL_EMOTION_TOUR_TITLE",
    "source_string": "Cancel emotion tour",
    "translation": "Cancel emotion tour",
    "context": " -> BP_LM_CANCEL_EMOTION_TOUR_TITLE"
  },
  {
    "identifier": "BP_LM_CANCEL_OFFROAD_TRACK_TITLE",
    "source_string": "Cancel offroad track",
    "translation": "Cancel offroad track",
    "context": " -> BP_LM_CANCEL_OFFROAD_TRACK_TITLE"
  },
  {
    "identifier": "BP_LM_CENTRE_POINT",
    "source_string": "Click on the map to create a centre point",
    "translation": "Click on the map to create a centre point",
    "context": " -> BP_LM_CENTRE_POINT"
  },
  {
    "identifier": "BP_LM_CHANGE_IMG",
    "source_string": "Change image",
    "translation": "Change image",
    "context": " -> BP_LM_CHANGE_IMG"
  },
  {
    "identifier": "BP_LM_CIRCUIT_COORDINATES_LBL",
    "source_string": "Circuit coordinates",
    "translation": "Circuit coordinates",
    "context": " -> BP_LM_CIRCUIT_COORDINATES_LBL"
  },
  {
    "identifier": "BP_LM_CIRCUIT_COORDINATES_REQ",
    "source_string": "Circuit coordinates cannot be null or empty",
    "translation": "Circuit coordinates cannot be null or empty",
    "context": " -> BP_LM_CIRCUIT_COORDINATES_REQ"
  },
  {
    "identifier": "BP_LM_CIRCUIT_CREATE_ERR",
    "source_string": "Either provide 'encodedPolyline' or 'coordinates' to create a circuit.",
    "translation": "Either provide 'encodedPolyline' or 'coordinates' to create a circuit.",
    "context": " -> BP_LM_CIRCUIT_CREATE_ERR"
  },
  {
    "identifier": "BP_LM_CIRCUIT_CREATED_SUCCESS",
    "source_string": "Circuit created successfully.",
    "translation": "Circuit created successfully.",
    "context": " -> BP_LM_CIRCUIT_CREATED_SUCCESS"
  },
  {
    "identifier": "BP_LM_CIRCUIT_DELETED_SUCCESS",
    "source_string": "Circuit deleted successfully.",
    "translation": "Circuit deleted successfully.",
    "context": " -> BP_LM_CIRCUIT_DELETED_SUCCESS"
  },
  {
    "identifier": "BP_LM_CIRCUIT_GEO_FENCE_AREA",
    "source_string": "Circuit geo-fence area",
    "translation": "Circuit geo-fence area",
    "context": " -> BP_LM_CIRCUIT_GEO_FENCE_AREA"
  },
  {
    "identifier": "BP_LM_CIRCUIT_NAME_REQ",
    "source_string": "Circuit name cannot be null or empty",
    "translation": "Circuit name cannot be null or empty",
    "context": " -> BP_LM_CIRCUIT_NAME_REQ"
  },
  {
    "identifier": "BP_LM_CIRCUIT_RADIUS_LBL",
    "source_string": "Circuit radius",
    "translation": "Circuit radius",
    "context": " -> BP_LM_CIRCUIT_RADIUS_LBL"
  },
  {
    "identifier": "BP_LM_CIRCUIT_RADIUS_REQ",
    "source_string": "Circuit radius cannot be null or empty",
    "translation": "Circuit radius cannot be null or empty",
    "context": " -> BP_LM_CIRCUIT_RADIUS_REQ"
  },
  {
    "identifier": "BP_LM_CIRCUIT_RESET_MSG",
    "source_string": "The current geo-fence will be reset when a new tool is used",
    "translation": "The current geo-fence will be reset when a new tool is used",
    "context": " -> BP_LM_CIRCUIT_RESET_MSG"
  },
  {
    "identifier": "BP_LM_CIRCUIT_SEARCH",
    "source_string": "Type circuit name city etc..",
    "translation": "Type circuit name city etc..",
    "context": " -> BP_LM_CIRCUIT_SEARCH"
  },
  {
    "identifier": "BP_LM_CIRCUIT_TYPE_REQ",
    "source_string": "Circuit type cannot be null or empty",
    "translation": "Circuit type cannot be null or empty",
    "context": " -> BP_LM_CIRCUIT_TYPE_REQ"
  },
  {
    "identifier": "BP_LM_CIRCUIT_UPDATED_SUCCESS",
    "source_string": "Circuit updated successfully.",
    "translation": "Circuit updated successfully.",
    "context": " -> BP_LM_CIRCUIT_UPDATED_SUCCESS"
  },
  {
    "identifier": "BP_LM_CIRCUIT_WRONG_FILE_UPLOADED_ERR",
    "source_string": "Please upload a file in .gpx format",
    "translation": "Please upload a file in .gpx format",
    "context": " -> BP_LM_CIRCUIT_WRONG_FILE_UPLOADED_ERR"
  },
  {
    "identifier": "BP_LM_CIRCUITS_LBL",
    "source_string": "Circuits",
    "translation": "Circuits",
    "context": " -> BP_LM_CIRCUITS_LBL"
  },
  {
    "identifier": "BP_LM_CLEAR_LBL",
    "source_string": "Clear",
    "translation": "Clear",
    "context": " -> BP_LM_CLEAR_LBL"
  },
  {
    "identifier": "BP_LM_CLOSE_BTN_LBL",
    "source_string": "Close",
    "translation": "Close",
    "context": " -> BP_LM_CLOSE_BTN_LBL"
  },
  {
    "identifier": "BP_LM_CONFIRM_ALERT_MESSAGE",
    "source_string": "Are you sure you want to leave the page? Any changes that you made will not be saved.",
    "translation": "Are you sure you want to leave the page? Any changes that you made will not be saved.",
    "context": " -> BP_LM_CONFIRM_ALERT_MESSAGE"
  },
  {
    "identifier": "BP_LM_CONFIRM_CANCEL",
    "source_string": "Confirm cancel",
    "translation": "Confirm cancel",
    "context": " -> BP_LM_CONFIRM_CANCEL"
  },
  {
    "identifier": "BP_LM_CONFIRM_DELETE_MESSAGE",
    "source_string": "Are you sure you want to delete this circuit?",
    "translation": "Are you sure you want to delete this circuit?",
    "context": " -> BP_LM_CONFIRM_DELETE_MESSAGE"
  },
  {
    "identifier": "BP_LM_CONFIRM_DELETE_TITLE",
    "source_string": "Confirm Delete ",
    "translation": "Confirm Delete ",
    "context": " -> BP_LM_CONFIRM_DELETE_TITLE"
  },
  {
    "identifier": "BP_LM_CONFIRM_SUBTITLE",
    "source_string": "Are you sure you want to cancel? Any changes you made will not be saved.",
    "translation": "Are you sure you want to cancel? Any changes you made will not be saved.",
    "context": " -> BP_LM_CONFIRM_SUBTITLE"
  },
  {
    "identifier": "BP_LM_COPYRIGHT_INFO",
    "source_string": "<span class=\"info-txt\"><a href=\"{placeholderImgURl}\" target=\"_blank\" rel=\"noopener noreferrer\">Photo</a></span> by {placeholderName} on <span class=\"info-txt\"><a href=\"{placeholderImgLicense}\" target=\"_blank\" rel=\"noopener noreferrer\">{placeholderLicense}</a></span>",
    "translation": "<span class=\"info-txt\"><a href=\"{placeholderImgURl}\" target=\"_blank\" rel=\"noopener noreferrer\">Photo</a></span> by {placeholderName} on <span class=\"info-txt\"><a href=\"{placeholderImgLicense}\" target=\"_blank\" rel=\"noopener noreferrer\">{placeholderLicense}</a></span>",
    "context": " -> BP_LM_COPYRIGHT_INFO"
  },
  {
    "identifier": "BP_LM_CREATE_BTN_LBL",
    "source_string": "Create",
    "translation": "Create",
    "context": " -> BP_LM_CREATE_BTN_LBL"
  },
  {
    "identifier": "BP_LM_CREATE_GEO_AREA",
    "source_string": "Start adding points on map to create a geo fence area",
    "translation": "Start adding points on map to create a geo fence area",
    "context": " -> BP_LM_CREATE_GEO_AREA"
  },
  {
    "identifier": "BP_LM_CREATED_TOUR_LBL",
    "source_string": "Created by <strong>{placeholderName}</strong> on <strong>{placeholderDate}</strong>",
    "translation": "Created by <strong>{placeholderName}</strong> on <strong>{placeholderDate}</strong>",
    "context": " -> BP_LM_CREATED_TOUR_LBL"
  },
  {
    "identifier": "BP_LM_CREATING_TRK_UNDER_LBL",
    "source_string": "Creating <strong>{placeholderTrackType}</strong> under <strong>{placeholderGroupName}</strong>",
    "translation": "Creating <strong>{placeholderTrackType}</strong> under <strong>{placeholderGroupName}</strong>",
    "context": " -> BP_LM_CREATING_TRK_UNDER_LBL"
  },
  {
    "identifier": "BP_LM_CTG_CULTURAL",
    "source_string": "Cultural",
    "translation": "Cultural",
    "context": " -> BP_LM_CTG_CULTURAL"
  },
  {
    "identifier": "BP_LM_CTG_EXPLORE_NATURE",
    "source_string": "Explore nature",
    "translation": "Explore nature",
    "context": " -> BP_LM_CTG_EXPLORE_NATURE"
  },
  {
    "identifier": "BP_LM_CTG_FASTEST",
    "source_string": "Fastest",
    "translation": "Fastest",
    "context": " -> BP_LM_CTG_FASTEST"
  },
  {
    "identifier": "BP_LM_CTG_FIELD_TRIP",
    "source_string": "Field trip",
    "translation": "Field trip",
    "context": " -> BP_LM_CTG_FIELD_TRIP"
  },
  {
    "identifier": "BP_LM_CTG_LUX_PRFRMNC",
    "source_string": "Luxury performance",
    "translation": "Luxury performance",
    "context": " -> BP_LM_CTG_LUX_PRFRMNC"
  },
  {
    "identifier": "BP_LM_CTG_PANORAMA",
    "source_string": "Panorama",
    "translation": "Panorama",
    "context": " -> BP_LM_CTG_PANORAMA"
  },
  {
    "identifier": "BP_LM_CTG_SCNC_PNTS",
    "source_string": "Scenic spots",
    "translation": "Scenic spots",
    "context": " -> BP_LM_CTG_SCNC_PNTS"
  },
  {
    "identifier": "BP_LM_CTG_SIGHT_SEEING",
    "source_string": "Sightseeing",
    "translation": "Sightseeing",
    "context": " -> BP_LM_CTG_SIGHT_SEEING"
  },
  {
    "identifier": "BP_LM_CTG_STRAIGHT_AHEAD",
    "source_string": "Straight ahead",
    "translation": "Straight ahead",
    "context": " -> BP_LM_CTG_STRAIGHT_AHEAD"
  },
  {
    "identifier": "BP_LM_CTG_UPS_DOWNS",
    "source_string": "Ups and downs",
    "translation": "Ups and downs",
    "context": " -> BP_LM_CTG_UPS_DOWNS"
  },
  {
    "identifier": "BP_LM_CTG_WATER_VIEW",
    "source_string": "Water view",
    "translation": "Water view",
    "context": " -> BP_LM_CTG_WATER_VIEW"
  },
  {
    "identifier": "BP_LM_CUTARED_TOUR_BTN_LABEL",
    "source_string": "Continue without annotations",
    "translation": "Continue without annotations",
    "context": " -> BP_LM_CUTARED_TOUR_BTN_LABEL"
  },
  {
    "identifier": "BP_LM_DELETE_COVER_IMAGE",
    "source_string": "Delete cover image",
    "translation": "Delete cover image",
    "context": " -> BP_LM_DELETE_COVER_IMAGE"
  },
  {
    "identifier": "BP_LM_DELETE_EMOTION_TOUR_MSG",
    "source_string": "Are you sure you want to delete this emotion tour?",
    "translation": "Are you sure you want to delete this emotion tour?",
    "context": " -> BP_LM_DELETE_EMOTION_TOUR_MSG"
  },
  {
    "identifier": "BP_LM_DELETE_ET_TITLE",
    "source_string": "Delete emotion tour",
    "translation": "Delete emotion tour",
    "context": " -> BP_LM_DELETE_ET_TITLE"
  },
  {
    "identifier": "BP_LM_DELETE_INSIDER_SPT_MSG",
    "source_string": "Are you sure you want to delete the insider spot '<strong>{placeholderInsiderspotName}</strong>' from this tour?",
    "translation": "Are you sure you want to delete the insider spot '<strong>{placeholderInsiderspotName}</strong>' from this tour?",
    "context": " -> BP_LM_DELETE_INSIDER_SPT_MSG"
  },
  {
    "identifier": "BP_LM_DELETE_OFFROAD_TITLE",
    "source_string": "Delete offroad track",
    "translation": "Delete offroad track",
    "context": " -> BP_LM_DELETE_OFFROAD_TITLE"
  },
  {
    "identifier": "BP_LM_DELETE_OFFROAD_TRACK_MSG",
    "source_string": "Are you sure you want to delete this offroad track?",
    "translation": "Are you sure you want to delete this offroad track?",
    "context": " -> BP_LM_DELETE_OFFROAD_TRACK_MSG"
  },
  {
    "identifier": "BP_LM_DELETE_TRACK_LAYOUT",
    "source_string": "Are you sure you want to delete this track layout?",
    "translation": "Are you sure you want to delete this track layout?",
    "context": " -> BP_LM_DELETE_TRACK_LAYOUT"
  },
  {
    "identifier": "BP_LM_DELETE_TRACK_MSG",
    "source_string": "Are you sure you want to delete this track?",
    "translation": "Are you sure you want to delete this track?",
    "context": " -> BP_LM_DELETE_TRACK_MSG"
  },
  {
    "identifier": "BP_LM_DELETE_TRACK_TITLE",
    "source_string": "Delete track",
    "translation": "Delete track",
    "context": " -> BP_LM_DELETE_TRACK_TITLE"
  },
  {
    "identifier": "BP_LM_DESTINATION",
    "source_string": "Destination",
    "translation": "Destination",
    "context": " -> BP_LM_DESTINATION"
  },
  {
    "identifier": "BP_LM_DISCARD_EDIT_INSIDER_SPOT_MSG",
    "source_string": "Are you sure you want to cancel. This will discard your progress.",
    "translation": "Are you sure you want to cancel. This will discard your progress.",
    "context": " -> BP_LM_DISCARD_EDIT_INSIDER_SPOT_MSG"
  },
  {
    "identifier": "BP_LM_DISCARD_EMOTION_TOUR_MSG",
    "source_string": "Are you sure you want cancel this tour? All progress made to this tour will be lost.",
    "translation": "Are you sure you want cancel this tour? All progress made to this tour will be lost.",
    "context": " -> BP_LM_DISCARD_EMOTION_TOUR_MSG"
  },
  {
    "identifier": "BP_LM_DISCARD_INSIDER_SPOT_MSG",
    "source_string": "Are you sure you want to cancel? All details added to this insider spot will be lost.",
    "translation": "Are you sure you want to cancel? All details added to this insider spot will be lost.",
    "context": " -> BP_LM_DISCARD_INSIDER_SPOT_MSG"
  },
  {
    "identifier": "BP_LM_DISCARD_OFFROAD_TRACK_MSG",
    "source_string": "Are you sure you want to cancel this offroad track? All progress made to this offroad track will be lost.",
    "translation": "Are you sure you want to cancel this offroad track? All progress made to this offroad track will be lost.",
    "context": " -> BP_LM_DISCARD_OFFROAD_TRACK_MSG"
  },
  {
    "identifier": "BP_LM_DLT_INSDR_SPT_TITLE",
    "source_string": "Delete insider spot",
    "translation": "Delete insider spot",
    "context": " -> BP_LM_DLT_INSDR_SPT_TITLE"
  },
  {
    "identifier": "BP_LM_DRAFT_LBL",
    "source_string": "Draft",
    "translation": "Draft",
    "context": " -> BP_LM_DRAFT_LBL"
  },
  {
    "identifier": "BP_LM_DRAG_GEOFENCE_MSG",
    "source_string": "Hold and drag to move the geo fence area",
    "translation": "Hold and drag to move the geo fence area",
    "context": " -> BP_LM_DRAG_GEOFENCE_MSG"
  },
  {
    "identifier": "BP_LM_DRIVE_EXPRIENCE",
    "source_string": "What they will experience while driving",
    "translation": "What they will experience while driving",
    "context": " -> BP_LM_DRIVE_EXPRIENCE"
  },
  {
    "identifier": "BP_LM_EDIT_DETAILS",
    "source_string": "EDIT DETAILS",
    "translation": "EDIT DETAILS",
    "context": " -> BP_LM_EDIT_DETAILS"
  },
  {
    "identifier": "BP_LM_EDIT_GEOFENCE_BTN_LBL",
    "source_string": "Edit geo-fence",
    "translation": "Edit geo-fence",
    "context": " -> BP_LM_EDIT_GEOFENCE_BTN_LBL"
  },
  {
    "identifier": "BP_LM_EDT_INSDR_SPT_NEW",
    "source_string": "Edit insider spot",
    "translation": "Edit insider spot",
    "context": " -> BP_LM_EDT_INSDR_SPT_NEW"
  },
  {
    "identifier": "BP_LM_EMOTION_TOUR_LBL",
    "source_string": "Emotion tour",
    "translation": "Emotion tour",
    "context": " -> BP_LM_EMOTION_TOUR_LBL"
  },
  {
    "identifier": "BP_LM_EMOTION_TOUR_SEARCH_TEXT",
    "source_string": "Search emotion tours around the world",
    "translation": "Search emotion tours around the world",
    "context": " -> BP_LM_EMOTION_TOUR_SEARCH_TEXT"
  },
  {
    "identifier": "BP_LM_EMPTY_GEOFENCE_ERROR",
    "source_string": "Couldn’t validate empty Geo-fence",
    "translation": "Couldn’t validate empty Geo-fence",
    "context": " -> BP_LM_EMPTY_GEOFENCE_ERROR"
  },
  {
    "identifier": "BP_LM_ENHANCING_TRK_MSG",
    "source_string": "Enhancing your tour, please wait this might take a few seconds.",
    "translation": "Enhancing your tour, please wait this might take a few seconds.",
    "context": " -> BP_LM_ENHANCING_TRK_MSG"
  },
  {
    "identifier": "BP_LM_ENTER_CIRCUIT_NAME",
    "source_string": "Enter circuit name",
    "translation": "Enter circuit name",
    "context": " -> BP_LM_ENTER_CIRCUIT_NAME"
  },
  {
    "identifier": "BP_LM_ENTER_TOUR_NAME",
    "source_string": "Enter tour name",
    "translation": "Enter tour name",
    "context": " -> BP_LM_ENTER_TOUR_NAME"
  },
  {
    "identifier": "BP_LM_ET_AMG_ANNOTATION_EXISTS",
    "source_string": "AMG annotation already exists with annotationId",
    "translation": "AMG annotation already exists with annotationId",
    "context": " -> BP_LM_ET_AMG_ANNOTATION_EXISTS"
  },
  {
    "identifier": "BP_LM_ET_GUID_REQ",
    "source_string": "Track guid cannot be null or empty",
    "translation": "Track guid cannot be null or empty",
    "context": " -> BP_LM_ET_GUID_REQ"
  },
  {
    "identifier": "BP_LM_ET_INVALID_GUID",
    "source_string": "No emotion tour found for this guid.",
    "translation": "No emotion tour found for this guid.",
    "context": " -> BP_LM_ET_INVALID_GUID"
  },
  {
    "identifier": "BP_LM_ET_INVLAID_TRACK_FORMAT",
    "source_string": "Invalid track GUID format",
    "translation": "Invalid track GUID format",
    "context": " -> BP_LM_ET_INVLAID_TRACK_FORMAT"
  },
  {
    "identifier": "BP_LM_ET_NAME_REQ",
    "source_string": "Tour name cannot be null or empty",
    "translation": "Tour name cannot be null or empty",
    "context": " -> BP_LM_ET_NAME_REQ"
  },
  {
    "identifier": "BP_LM_ET_TOUR_ID_REQ",
    "source_string": "Tour ID cannot be null or empty",
    "translation": "Tour ID cannot be null or empty",
    "context": " -> BP_LM_ET_TOUR_ID_REQ"
  },
  {
    "identifier": "BP_LM_FILE_UPLOAD_ERR",
    "source_string": "File upload error",
    "translation": "File upload error",
    "context": " -> BP_LM_FILE_UPLOAD_ERR"
  },
  {
    "identifier": "BP_LM_FIND_YOUR_TRACKS_MSG",
    "source_string": "Find your created Tracks and tours",
    "translation": "Find your created Tracks and tours",
    "context": " -> BP_LM_FIND_YOUR_TRACKS_MSG"
  },
  {
    "identifier": "BP_LM_FLORA_FAUNA_MSG",
    "source_string": "Yes, include the flora and fauna annotations and information from the gpx file.",
    "translation": "Yes, include the flora and fauna annotations and information from the gpx file.",
    "context": " -> BP_LM_FLORA_FAUNA_MSG"
  },
  {
    "identifier": "BP_LM_FLORA_FAUNA_TITLE",
    "source_string": "Do you want to include the flora and fauna annotations?",
    "translation": "Do you want to include the flora and fauna annotations?",
    "context": " -> BP_LM_FLORA_FAUNA_TITLE"
  },
  {
    "identifier": "BP_LM_GENERATE_TOUR_BTN_LBL",
    "source_string": "Generate tour",
    "translation": "Generate tour",
    "context": " -> BP_LM_GENERATE_TOUR_BTN_LBL"
  },
  {
    "identifier": "BP_LM_GEO_FENCE_OVERLAP_ERR",
    "source_string": "Geofence overlaps with another geofence.",
    "translation": "Geofence overlaps with another geofence.",
    "context": " -> BP_LM_GEO_FENCE_OVERLAP_ERR"
  },
  {
    "identifier": "BP_LM_GEO_FENCE_RADIUS_MSG",
    "source_string": "Enter geo fence radius",
    "translation": "Enter geo fence radius",
    "context": " -> BP_LM_GEO_FENCE_RADIUS_MSG"
  },
  {
    "identifier": "BP_LM_GEOFENCE_VALIDATION_ERROR",
    "source_string": "Couldn’t validate the Geo-fence",
    "translation": "Couldn’t validate the Geo-fence",
    "context": " -> BP_LM_GEOFENCE_VALIDATION_ERROR"
  },
  {
    "identifier": "BP_LM_GEOFENCE_VALIDATION_ERROR_MSG",
    "source_string": "Another geo-fence already exists in this area.",
    "translation": "Another geo-fence already exists in this area.",
    "context": " -> BP_LM_GEOFENCE_VALIDATION_ERROR_MSG"
  },
  {
    "identifier": "BP_LM_GPX_LYT",
    "source_string": "gpx layout",
    "translation": "gpx layout",
    "context": " -> BP_LM_GPX_LYT"
  },
  {
    "identifier": "BP_LM_GPX_MSG",
    "source_string": "Do you have a gpx file ? Please use below button to upload and plot it on the map.",
    "translation": "Do you have a gpx file ? Please use below button to upload and plot it on the map.",
    "context": " -> BP_LM_GPX_MSG"
  },
  {
    "identifier": "BP_LM_HIGHLIGHT_LBL",
    "source_string": "Highlight",
    "translation": "Highlight",
    "context": " -> BP_LM_HIGHLIGHT_LBL"
  },
  {
    "identifier": "BP_LM_HIGHLIGHTS",
    "source_string": "Highlights",
    "translation": "Highlights",
    "context": " -> BP_LM_HIGHLIGHTS"
  },
  {
    "identifier": "BP_LM_IMAGE_ATTRIBUTION",
    "source_string": "Image attribution",
    "translation": "Image attribution",
    "context": " -> BP_LM_IMAGE_ATTRIBUTION"
  },
  {
    "identifier": "BP_LM_IMAGE_COPYRIGHT_DETAILS",
    "source_string": "Image copyright details",
    "translation": "Image copyright details",
    "context": " -> BP_LM_IMAGE_COPYRIGHT_DETAILS"
  },
  {
    "identifier": "BP_LM_IMAGE_COPYRIGHT_INFO",
    "source_string": "Image copyright information",
    "translation": "Image copyright information",
    "context": " -> BP_LM_IMAGE_COPYRIGHT_INFO"
  },
  {
    "identifier": "BP_LM_IMAGE_COPYRIGHT_SAVED_SUCCESS_MSG",
    "source_string": "Your images and copyright information have been successfully saved.",
    "translation": "Your images and copyright information have been successfully saved.",
    "context": " -> BP_LM_IMAGE_COPYRIGHT_SAVED_SUCCESS_MSG"
  },
  {
    "identifier": "BP_LM_IMAGE_LICENSE",
    "source_string": "Image license",
    "translation": "Image license",
    "context": " -> BP_LM_IMAGE_LICENSE"
  },
  {
    "identifier": "BP_LM_IMAGE_PREVIEW_LBL",
    "source_string": "Image preview",
    "translation": "Image preview",
    "context": " -> BP_LM_IMAGE_PREVIEW_LBL"
  },
  {
    "identifier": "BP_LM_IMAGE_URL",
    "source_string": "Image URL",
    "translation": "Image URL",
    "context": " -> BP_LM_IMAGE_URL"
  },
  {
    "identifier": "BP_LM_INSIDER_SPOT_CREATED_SUCCESS",
    "source_string": "Insider spot created successfully.",
    "translation": "Insider spot created successfully.",
    "context": " -> BP_LM_INSIDER_SPOT_CREATED_SUCCESS"
  },
  {
    "identifier": "BP_LM_INSIDER_SPOT_DELETED_SUCCESS",
    "source_string": "Insider spot deleted successfully.",
    "translation": "Insider spot deleted successfully.",
    "context": " -> BP_LM_INSIDER_SPOT_DELETED_SUCCESS"
  },
  {
    "identifier": "BP_LM_INSIDER_SPOT_UPDATED_SUCCESS",
    "source_string": "Insider spot updated successfully.",
    "translation": "Insider spot updated successfully.",
    "context": " -> BP_LM_INSIDER_SPOT_UPDATED_SUCCESS"
  },
  {
    "identifier": "BP_LM_INVALID_PHONE_NUMBER",
    "source_string": "Invalid phone number",
    "translation": "Invalid phone number",
    "context": " -> BP_LM_INVALID_PHONE_NUMBER"
  },
  {
    "identifier": "BP_LM_INVALID_VALUE_ENETERED",
    "source_string": "Invalid value entered. Type a value between 0 and 100.",
    "translation": "Invalid value entered. Type a value between 0 and 100.",
    "context": " -> BP_LM_INVALID_VALUE_ENETERED"
  },
  {
    "identifier": "BP_LM_LAYOUT_DETAILS",
    "source_string": "Layout details",
    "translation": "Layout details",
    "context": " -> BP_LM_LAYOUT_DETAILS"
  },
  {
    "identifier": "BP_LM_LAYOUT_LENGTH",
    "source_string": "Layout length",
    "translation": "Layout length",
    "context": " -> BP_LM_LAYOUT_LENGTH"
  },
  {
    "identifier": "BP_LM_LAYOUT_NAME",
    "source_string": "Layout name",
    "translation": "Layout name",
    "context": " -> BP_LM_LAYOUT_NAME"
  },
  {
    "identifier": "BP_LM_LAYOUT_URL",
    "source_string": "Layout URL",
    "translation": "Layout URL",
    "context": " -> BP_LM_LAYOUT_URL"
  },
  {
    "identifier": "BP_LM_LENGTH",
    "source_string": "LENGTH",
    "translation": "LENGTH",
    "context": " -> BP_LM_LENGTH"
  },
  {
    "identifier": "BP_LM_LICENCE_URL",
    "source_string": "License URL",
    "translation": "License URL",
    "context": " -> BP_LM_LICENCE_URL"
  },
  {
    "identifier": "BP_LM_LOCATIONS_TITLE",
    "source_string": "Locations",
    "translation": "Locations",
    "context": " -> BP_LM_LOCATIONS_TITLE"
  },
  {
    "identifier": "BP_LM_MAX_ALLOWED_MEDIA_MSG",
    "source_string": "Max 1 image is allowed.",
    "translation": "Max 1 image is allowed.",
    "context": " -> BP_LM_MAX_ALLOWED_MEDIA_MSG"
  },
  {
    "identifier": "BP_LM_MAX_ONE_MEDIA_FILE",
    "source_string": "You can upload only one media file for the circuit.",
    "translation": "You can upload only one media file for the circuit.",
    "context": " -> BP_LM_MAX_ONE_MEDIA_FILE"
  },
  {
    "identifier": "BP_LM_NEW_LAYOUT_BTN_LBL",
    "source_string": "New layout",
    "translation": "New layout",
    "context": " -> BP_LM_NEW_LAYOUT_BTN_LBL"
  },
  {
    "identifier": "BP_LM_NEW_LBL",
    "source_string": "New",
    "translation": "New",
    "context": " -> BP_LM_NEW_LBL"
  },
  {
    "identifier": "BP_LM_NEXT_BTN_LBL",
    "source_string": "Next",
    "translation": "Next",
    "context": " -> BP_LM_NEXT_BTN_LBL"
  },
  {
    "identifier": "BP_LM_NEXT_STEPS_MSG",
    "source_string": "Taking you to next steps...",
    "translation": "Taking you to next steps...",
    "context": " -> BP_LM_NEXT_STEPS_MSG"
  },
  {
    "identifier": "BP_LM_NO_LAYOUTS_AVAILABLE_MSG",
    "source_string": "No track layouts available for this circuit. Start creating now",
    "translation": "No track layouts available for this circuit. Start creating now",
    "context": " -> BP_LM_NO_LAYOUTS_AVAILABLE_MSG"
  },
  {
    "identifier": "BP_LM_NO_OF_LAYOUTS",
    "source_string": "No. of layouts",
    "translation": "No. of layouts",
    "context": " -> BP_LM_NO_OF_LAYOUTS"
  },
  {
    "identifier": "BP_LM_NO_RACE_RESULTS",
    "source_string": "No activity is currently avaiable. Kindly refresh the page",
    "translation": "No activity is currently avaiable. Kindly refresh the page",
    "context": " -> BP_LM_NO_RACE_RESULTS"
  },
  {
    "identifier": "BP_LM_NO_RESULTS",
    "source_string": "No results for",
    "translation": "No results for",
    "context": " -> BP_LM_NO_RESULTS"
  },
  {
    "identifier": "BP_LM_NO_SEARCH_RESULTS",
    "source_string": "No search results",
    "translation": "No search results",
    "context": " -> BP_LM_NO_SEARCH_RESULTS"
  },
  {
    "identifier": "BP_LM_OFFROAD_ADV_LBL",
    "source_string": "Offroad Track",
    "translation": "Offroad Track",
    "context": " -> BP_LM_OFFROAD_ADV_LBL"
  },
  {
    "identifier": "BP_LM_OFFROAD_CREATED_SUCCESS",
    "source_string": "Offroad track created successfully.",
    "translation": "Offroad track created successfully.",
    "context": " -> BP_LM_OFFROAD_CREATED_SUCCESS"
  },
  {
    "identifier": "BP_LM_OFFROAD_DELETED_SUCCESS",
    "source_string": "Offroad track deleted successfully.",
    "translation": "Offroad track deleted successfully.",
    "context": " -> BP_LM_OFFROAD_DELETED_SUCCESS"
  },
  {
    "identifier": "BP_LM_OFFROAD_LBL",
    "source_string": "Offroad",
    "translation": "Offroad",
    "context": " -> BP_LM_OFFROAD_LBL"
  },
  {
    "identifier": "BP_LM_OFFROAD_PARK_LBL",
    "source_string": "Offroad park",
    "translation": "Offroad park",
    "context": " -> BP_LM_OFFROAD_PARK_LBL"
  },
  {
    "identifier": "BP_LM_OFFROAD_UPDATED_SUCCESS",
    "source_string": "Offroad track updated successfully.",
    "translation": "Offroad track updated successfully.",
    "context": " -> BP_LM_OFFROAD_UPDATED_SUCCESS"
  },
  {
    "identifier": "BP_LM_OR",
    "source_string": "Or",
    "translation": "Or",
    "context": " -> BP_LM_OR"
  },
  {
    "identifier": "BP_LM_PERMANENT",
    "source_string": "Permanent",
    "translation": "Permanent",
    "context": " -> BP_LM_PERMANENT"
  },
  {
    "identifier": "BP_LM_PICK_CATEGORY",
    "source_string": "Pick a category for your tour",
    "translation": "Pick a category for your tour",
    "context": " -> BP_LM_PICK_CATEGORY"
  },
  {
    "identifier": "BP_LM_POLYLINE_LBL",
    "source_string": "Polyline",
    "translation": "Polyline",
    "context": " -> BP_LM_POLYLINE_LBL"
  },
  {
    "identifier": "BP_LM_PPM_BADGE_TXT",
    "source_string": "PPM",
    "translation": "PPM",
    "context": " -> BP_LM_PPM_BADGE_TXT"
  },
  {
    "identifier": "BP_LM_PROFILE",
    "source_string": "Profile",
    "translation": "Profile",
    "context": " -> BP_LM_PROFILE"
  },
  {
    "identifier": "BP_LM_PUBLISH_BTN_LBL",
    "source_string": "Publish",
    "translation": "Publish",
    "context": " -> BP_LM_PUBLISH_BTN_LBL"
  },
  {
    "identifier": "BP_LM_PUBLISH_NOW",
    "source_string": "Publish now",
    "translation": "Publish now",
    "context": " -> BP_LM_PUBLISH_NOW"
  },
  {
    "identifier": "BP_LM_RADIUS_LBL",
    "source_string": "Radius",
    "translation": "Radius",
    "context": " -> BP_LM_RADIUS_LBL"
  },
  {
    "identifier": "BP_LM_RENAME_ADD_LBL",
    "source_string": "Re-name address",
    "translation": "Re-name address",
    "context": " -> BP_LM_RENAME_ADD_LBL"
  },
  {
    "identifier": "BP_LM_ROUND_TRIP_NOTE",
    "source_string": "Skip adding your destination and create round trip back to your start.",
    "translation": "Skip adding your destination and create round trip back to your start.",
    "context": " -> BP_LM_ROUND_TRIP_NOTE"
  },
  {
    "identifier": "BP_LM_SAVE_DRAFT_BTN_LBL",
    "source_string": "Save as draft",
    "translation": "Save as draft",
    "context": " -> BP_LM_SAVE_DRAFT_BTN_LBL"
  },
  {
    "identifier": "BP_LM_SAVE_INSIDER_POINT_BTN_LBL",
    "source_string": "Add insider spot",
    "translation": "Add insider spot",
    "context": " -> BP_LM_SAVE_INSIDER_POINT_BTN_LBL"
  },
  {
    "identifier": "BP_LM_SAVE_PUBLISH_BTN_LBL",
    "source_string": "Save and publish",
    "translation": "Save and publish",
    "context": " -> BP_LM_SAVE_PUBLISH_BTN_LBL"
  },
  {
    "identifier": "BP_LM_SAVE_UPDATE_BTN_LBL",
    "source_string": "Save and update",
    "translation": "Save and update",
    "context": " -> BP_LM_SAVE_UPDATE_BTN_LBL"
  },
  {
    "identifier": "BP_LM_SCANNING_GEOFENCE_MSG",
    "source_string": "Scanning your Geo-fence",
    "translation": "Scanning your Geo-fence",
    "context": " -> BP_LM_SCANNING_GEOFENCE_MSG"
  },
  {
    "identifier": "BP_LM_SEARCH_BY_LOCATION",
    "source_string": "Search by location name etc...",
    "translation": "Search by location name etc...",
    "context": " -> BP_LM_SEARCH_BY_LOCATION"
  },
  {
    "identifier": "BP_LM_SEARCH_GEO_FENCE",
    "source_string": "Search or find the location on the map to create the geo-fence.",
    "translation": "Search or find the location on the map to create the geo-fence.",
    "context": " -> BP_LM_SEARCH_GEO_FENCE"
  },
  {
    "identifier": "BP_LM_SEARCH_LBL",
    "source_string": "Search",
    "translation": "Search",
    "context": " -> BP_LM_SEARCH_LBL"
  },
  {
    "identifier": "BP_LM_SEARCH_TEXT",
    "source_string": "Search circuits and emotion tours around the world",
    "translation": "Search circuits and emotion tours around the world",
    "context": " -> BP_LM_SEARCH_TEXT"
  },
  {
    "identifier": "BP_LM_SECTOR_LABEL",
    "source_string": "Sector",
    "translation": "Sector",
    "context": " -> BP_LM_SECTOR_LABEL"
  },
  {
    "identifier": "BP_LM_SECTORS",
    "source_string": "Sectors",
    "translation": "Sectors",
    "context": " -> BP_LM_SECTORS"
  },
  {
    "identifier": "BP_LM_SELECT_LANG",
    "source_string": "Select language",
    "translation": "Select language",
    "context": " -> BP_LM_SELECT_LANG"
  },
  {
    "identifier": "BP_LM_SEND_TRACK_TO_FLEET_MSG",
    "source_string": "Publishing this track will be sent to all cars in your fleet under the favourites section.",
    "translation": "Publishing this track will be sent to all cars in your fleet under the favourites section.",
    "context": " -> BP_LM_SEND_TRACK_TO_FLEET_MSG"
  },
  {
    "identifier": "BP_LM_SET_CENTER_CIRCLULAR",
    "source_string": "Set the centre point to plot a circular geo-fence",
    "translation": "Set the centre point to plot a circular geo-fence",
    "context": " -> BP_LM_SET_CENTER_CIRCLULAR"
  },
  {
    "identifier": "BP_LM_SET_CIRCUIT_NAME",
    "source_string": "Set circuit type",
    "translation": "Set circuit type",
    "context": " -> BP_LM_SET_CIRCUIT_NAME"
  },
  {
    "identifier": "BP_LM_SET_DISPLAY_NAME",
    "source_string": "Set display name",
    "translation": "Set display name",
    "context": " -> BP_LM_SET_DISPLAY_NAME"
  },
  {
    "identifier": "BP_LM_SET_TRACK_TYPE",
    "source_string": "Set track type",
    "translation": "Set track type",
    "context": " -> BP_LM_SET_TRACK_TYPE"
  },
  {
    "identifier": "BP_LM_START",
    "source_string": "Start",
    "translation": "Start",
    "context": " -> BP_LM_START"
  },
  {
    "identifier": "BP_LM_START_CIRCUIT_CREATION",
    "source_string": "Click on the first point to end the process",
    "translation": "Click on the first point to end the process",
    "context": " -> BP_LM_START_CIRCUIT_CREATION"
  },
  {
    "identifier": "BP_LM_SUMMARY",
    "source_string": "View summary",
    "translation": "View summary",
    "context": " -> BP_LM_SUMMARY"
  },
  {
    "identifier": "BP_LM_TEMPORARY",
    "source_string": "Temporary",
    "translation": "Temporary",
    "context": " -> BP_LM_TEMPORARY"
  },
  {
    "identifier": "BP_LM_TOUR_CREATED_SUCCESS",
    "source_string": "Emotion tour created successfully.",
    "translation": "Emotion tour created successfully.",
    "context": " -> BP_LM_TOUR_CREATED_SUCCESS"
  },
  {
    "identifier": "BP_LM_TOUR_DELETED_SUCCESS",
    "source_string": "Emotion tour deleted successfully.",
    "translation": "Emotion tour deleted successfully.",
    "context": " -> BP_LM_TOUR_DELETED_SUCCESS"
  },
  {
    "identifier": "BP_LM_TOUR_DETAILS",
    "source_string": "Tour details",
    "translation": "Tour details",
    "context": " -> BP_LM_TOUR_DETAILS"
  },
  {
    "identifier": "BP_LM_TOUR_DOES_NOT_EXIST",
    "source_string": "Tour does not exist",
    "translation": "Tour does not exist",
    "context": " -> BP_LM_TOUR_DOES_NOT_EXIST"
  },
  {
    "identifier": "BP_LM_TOUR_NAME_EMPTY",
    "source_string": "Tour name cannot be empty",
    "translation": "Tour name cannot be empty",
    "context": " -> BP_LM_TOUR_NAME_EMPTY"
  },
  {
    "identifier": "BP_LM_TOUR_SENT_SUCCESS",
    "source_string": "Tour sent to car successfully",
    "translation": "Tour sent to car successfully",
    "context": " -> BP_LM_TOUR_SENT_SUCCESS"
  },
  {
    "identifier": "BP_LM_TOUR_UPDATED_SUCCESS",
    "source_string": "Emotion tour updated successfully.",
    "translation": "Emotion tour updated successfully.",
    "context": " -> BP_LM_TOUR_UPDATED_SUCCESS"
  },
  {
    "identifier": "BP_LM_TRACK_CREATED_SUCCESS",
    "source_string": "Track created successfully.",
    "translation": "Track created successfully.",
    "context": " -> BP_LM_TRACK_CREATED_SUCCESS"
  },
  {
    "identifier": "BP_LM_TRACK_DELETED_SUCCESS",
    "source_string": "Track deleted successfully.",
    "translation": "Track deleted successfully.",
    "context": " -> BP_LM_TRACK_DELETED_SUCCESS"
  },
  {
    "identifier": "BP_LM_TRACK_DETAILS_UPDATE",
    "source_string": "Update",
    "translation": "Update",
    "context": " -> BP_LM_TRACK_DETAILS_UPDATE"
  },
  {
    "identifier": "BP_LM_TRACK_EXISTS_MSG",
    "source_string": "Track already exists.",
    "translation": "Track already exists.",
    "context": " -> BP_LM_TRACK_EXISTS_MSG"
  },
  {
    "identifier": "BP_LM_TRACK_OVERLAP_MSG",
    "source_string": "Geo-fences cannot overlap.",
    "translation": "Geo-fences cannot overlap.",
    "context": " -> BP_LM_TRACK_OVERLAP_MSG"
  },
  {
    "identifier": "BP_LM_TRACK_LBL",
    "source_string": "Track",
    "translation": "Track",
    "context": " -> BP_LM_TRACK_LBL"
  },
  {
    "identifier": "BP_LM_TRACK_PACE_LBL",
    "source_string": "AMG Track Pace",
    "translation": "AMG Track Pace",
    "context": " -> BP_LM_TRACK_PACE_LBL"
  },
  {
    "identifier": "BP_LM_TRACK_SEARCH_TEXT",
    "source_string": "Search circuits around the world",
    "translation": "Search circuits around the world",
    "context": " -> BP_LM_TRACK_SEARCH_TEXT"
  },
  {
    "identifier": "BP_LM_TRACK_TYPE",
    "source_string": "Track type",
    "translation": "Track type",
    "context": " -> BP_LM_TRACK_TYPE"
  },
  {
    "identifier": "BP_LM_TRACK_UPDATED_SUCCESS",
    "source_string": "Track updated successfully.",
    "translation": "Track updated successfully.",
    "context": " -> BP_LM_TRACK_UPDATED_SUCCESS"
  },
  {
    "identifier": "BP_LM_TRACKS_LBL",
    "source_string": "Tracks",
    "translation": "Tracks",
    "context": " -> BP_LM_TRACKS_LBL"
  },
  {
    "identifier": "BP_LM_TRK_GUID",
    "source_string": "Track GUID",
    "translation": "Track GUID",
    "context": " -> BP_LM_TRK_GUID"
  },
  {
    "identifier": "BP_LM_UNSAVED_CHANGES_WARNING",
    "source_string": "All your updates made to this insider spot will be lost. Do you want to continue?",
    "translation": "All your updates made to this insider spot will be lost. Do you want to continue?",
    "context": " -> BP_LM_UNSAVED_CHANGES_WARNING"
  },
  {
    "identifier": "BP_LM_UPDATE_DETAILS_BTN_LBL",
    "source_string": "Update details",
    "translation": "Update details",
    "context": " -> BP_LM_UPDATE_DETAILS_BTN_LBL"
  },
  {
    "identifier": "BP_LM_UPDT_DSTN",
    "source_string": "Edit destination",
    "translation": "Edit destination",
    "context": " -> BP_LM_UPDT_DSTN"
  },
  {
    "identifier": "BP_LM_UPDT_STRT",
    "source_string": "Edit start",
    "translation": "Edit start",
    "context": " -> BP_LM_UPDT_STRT"
  },
  {
    "identifier": "BP_LM_UPLOAD_AUDIO_FILE_LBL",
    "source_string": "Upload audio files",
    "translation": "Upload audio files",
    "context": " -> BP_LM_UPLOAD_AUDIO_FILE_LBL"
  },
  {
    "identifier": "BP_LM_UPLOAD_GPX_FILE_MSG",
    "source_string": "Please upload gpx file to add new layout to this circuit",
    "translation": "Please upload gpx file to add new layout to this circuit",
    "context": " -> BP_LM_UPLOAD_GPX_FILE_MSG"
  },
  {
    "identifier": "BP_LM_UPLOAD_TOUR",
    "source_string": "Upload a tour",
    "translation": "Upload a tour",
    "context": " -> BP_LM_UPLOAD_TOUR"
  },
  {
    "identifier": "BP_LM_UPLOADING",
    "source_string": "Uploading...",
    "translation": "Uploading...",
    "context": " -> BP_LM_UPLOADING"
  },
  {
    "identifier": "BP_LM_URL_COPIED_SUCCESS",
    "source_string": "URL copied to clipboard",
    "translation": "URL copied to clipboard",
    "context": " -> BP_LM_URL_COPIED_SUCCESS"
  },
  {
    "identifier": "BP_LM_VALIDATED_MSG",
    "source_string": "Validated",
    "translation": "Validated",
    "context": " -> BP_LM_VALIDATED_MSG"
  },
  {
    "identifier": "BP_LM_VALIDATING",
    "source_string": "Validating",
    "translation": "Validating",
    "context": " -> BP_LM_VALIDATING"
  },
  {
    "identifier": "BP_LM_VALIDATION_IN_PROGRESS",
    "source_string": "Validation in progress...",
    "translation": "Validation in progress...",
    "context": " -> BP_LM_VALIDATION_IN_PROGRESS"
  },
  {
    "identifier": "BP_LM_VIEW_SUMMARY_BTN_LBL",
    "source_string": "View summary",
    "translation": "View summary",
    "context": " -> BP_LM_VIEW_SUMMARY_BTN_LBL"
  },
  {
    "identifier": "BP_LM_WEBSITE",
    "source_string": "Website",
    "translation": "Website",
    "context": " -> BP_LM_WEBSITE"
  },
  {
    "identifier": "BP_LM_WIKIPEDIA",
    "source_string": "Wikipedia",
    "translation": "Wikipedia",
    "context": " -> BP_LM_WIKIPEDIA"
  },
  {
    "identifier": "BP_LM_WRONG_FILE_UPLOAD_ERR",
    "source_string": "Please upload a file in .gpx or .kml format",
    "translation": "Please upload a file in .gpx or .kml format",
    "context": " -> BP_LM_WRONG_FILE_UPLOAD_ERR"
  },
  {
    "identifier": "BP_LM_YOUR_TRACKS_LBL",
    "source_string": "Your tracks",
    "translation": "Your tracks",
    "context": " -> BP_LM_YOUR_TRACKS_LBL"
  },
  {
    "identifier": "BP_LM_ZOOM_GEO_FENCE_MSG",
    "source_string": "Zoom and pan through the map to start plotting the Geo-fence for your circuit",
    "translation": "Zoom and pan through the map to start plotting the Geo-fence for your circuit",
    "context": " -> BP_LM_ZOOM_GEO_FENCE_MSG"
  },
  {
    "identifier": "BP_LM_ZOOM_IN_LBL",
    "source_string": "Zoom in",
    "translation": "Zoom in",
    "context": " -> BP_LM_ZOOM_IN_LBL"
  },
  {
    "identifier": "BP_LM_ZOOM_IN_MSG",
    "source_string": "Click on zoom button to create geo fence area",
    "translation": "Click on zoom button to create geo fence area",
    "context": " -> BP_LM_ZOOM_IN_MSG"
  },
  {
    "identifier": "BP_PM_ACCESS_TYPE",
    "source_string": "Access type",
    "translation": "Access type",
    "context": " -> BP_PM_ACCESS_TYPE"
  },
  {
    "identifier": "BP_PM_ADD_EDIT_FLEET",
    "source_string": "Add, delete and manage your fleet here",
    "translation": "Add, delete and manage your fleet here",
    "context": " -> BP_PM_ADD_EDIT_FLEET"
  },
  {
    "identifier": "BP_PM_ADD_MEMBER",
    "source_string": "Member",
    "translation": "Member",
    "context": " -> BP_PM_ADD_MEMBER"
  },
  {
    "identifier": "BP_PM_ADD_MEMBER_TITLE",
    "source_string": "Add member",
    "translation": "Add member",
    "context": " -> BP_PM_ADD_MEMBER_TITLE"
  },
  {
    "identifier": "BP_PM_AN",
    "source_string": "Business name",
    "translation": "Business name",
    "context": " -> BP_PM_AN"
  },
  {
    "identifier": "BP_PM_BW",
    "source_string": "Business website",
    "translation": "Business website",
    "context": " -> BP_PM_BW"
  },
  {
    "identifier": "BP_PM_CAR",
    "source_string": "Car",
    "translation": "Car",
    "context": " -> BP_PM_CAR"
  },
  {
    "identifier": "BP_PM_CAR_ADDED_SUCCESSFULLY",
    "source_string": "Car successfully added to fleet",
    "translation": "Car successfully added to fleet",
    "context": " -> BP_PM_CAR_ADDED_SUCCESSFULLY"
  },
  {
    "identifier": "BP_PM_CAR_DETAILS_UPDATED",
    "source_string": "Car details updated",
    "translation": "Car details updated",
    "context": " -> BP_PM_CAR_DETAILS_UPDATED"
  },
  {
    "identifier": "BP_PM_CAR_FLEET",
    "source_string": "Add a new car to your fleet",
    "translation": "Add a new car to your fleet",
    "context": " -> BP_PM_CAR_FLEET"
  },
  {
    "identifier": "BP_PM_CAR_MODEL",
    "source_string": "Car model",
    "translation": "Car model",
    "context": " -> BP_PM_CAR_MODEL"
  },
  {
    "identifier": "BP_PM_CROP_PROFIMG",
    "source_string": "Crop profile image",
    "translation": "Crop profile image",
    "context": " -> BP_PM_CROP_PROFIMG"
  },
  {
    "identifier": "BP_PM_DELETE_FLEET_MESSAGE",
    "source_string": "Are you sure you want to delete <strong>{placeholderObject}</strong> from fleet?",
    "translation": "Are you sure you want to delete <strong>{placeholderObject}</strong> from fleet?",
    "context": " -> BP_PM_DELETE_FLEET_MESSAGE"
  },
  {
    "identifier": "BP_PM_EDIT_PROFILE",
    "source_string": "Edit Business details",
    "translation": "Edit Business details",
    "context": " -> BP_PM_EDIT_PROFILE"
  },
  {
    "identifier": "BP_PM_ERR_SMALLIMG",
    "source_string": "Upload image seems to be too small. Please upload higher quality image and try again",
    "translation": "Upload image seems to be too small. Please upload higher quality image and try again",
    "context": " -> BP_PM_ERR_SMALLIMG"
  },
  {
    "identifier": "BP_PM_FLEET",
    "source_string": "FLEET",
    "translation": "FLEET",
    "context": " -> BP_PM_FLEET"
  },
  {
    "identifier": "BP_PM_FLEET_EMPTY",
    "source_string": "Your fleet seems to be empty, start by adding a car",
    "translation": "Your fleet seems to be empty, start by adding a car",
    "context": " -> BP_PM_FLEET_EMPTY"
  },
  {
    "identifier": "BP_PM_FM_CAP",
    "source_string": "Car already present for the user",
    "translation": "Car already present for the user",
    "context": " -> BP_PM_FM_CAP"
  },
  {
    "identifier": "BP_PM_HI",
    "source_string": "Hi",
    "translation": "Hi",
    "context": " -> BP_PM_HI"
  },
  {
    "identifier": "BP_PM_JB",
    "source_string": "Join Business",
    "translation": "Join Business",
    "context": " -> BP_PM_JB"
  },
  {
    "identifier": "BP_PM_LARGEIMG",
    "source_string": "Uploaded image is too large. Please upload an image below 5mb and try again",
    "translation": "Uploaded image is too large. Please upload an image below 5mb and try again",
    "context": " -> BP_PM_LARGEIMG"
  },
  {
    "identifier": "BP_PM_LICENSE",
    "source_string": "License plate",
    "translation": "License plate",
    "context": " -> BP_PM_LICENSE"
  },
  {
    "identifier": "BP_PM_LICNO",
    "source_string": "License no",
    "translation": "License no",
    "context": " -> BP_PM_LICNO"
  },
  {
    "identifier": "BP_PM_LOGOUT",
    "source_string": "Logout",
    "translation": "Logout",
    "context": " -> BP_PM_LOGOUT"
  },
  {
    "identifier": "BP_PM_LP_PD",
    "source_string": "Please select the business you want to use to manage Mercedes me Stories services. Your account can be linked and operated under multiple businesses, You can change business anytime Under Profile section or can come back to this page.",
    "translation": "Please select the business you want to use to manage Mercedes me Stories services. Your account can be linked and operated under multiple businesses, You can change business anytime Under Profile section or can come back to this page.",
    "context": " -> BP_PM_LP_PD"
  },
  {
    "identifier": "BP_PM_LP_SB",
    "source_string": "Select Business",
    "translation": "Select Business",
    "context": " -> BP_PM_LP_SB"
  },
  {
    "identifier": "BP_PM_MANAGE_BUSINESS",
    "source_string": "Manage Business",
    "translation": "Manage Business",
    "context": " -> BP_PM_MANAGE_BUSINESS"
  },
  {
    "identifier": "BP_PM_MANAGE_FLEET",
    "source_string": "Manage Fleet",
    "translation": "Manage Fleet",
    "context": " -> BP_PM_MANAGE_FLEET"
  },
  {
    "identifier": "BP_PM_MEMBER",
    "source_string": "CIAM ID",
    "translation": "CIAM ID",
    "context": " -> BP_PM_MEMBER"
  },
  {
    "identifier": "BP_PM_MEMBERS_LIST",
    "source_string": "Members list",
    "translation": "Members list",
    "context": " -> BP_PM_MEMBERS_LIST"
  },
  {
    "identifier": "BP_PM_MODEL_DETAILS_UNAVALIABLE",
    "source_string": "Model details unavailable",
    "translation": "Model details unavailable",
    "context": " -> BP_PM_MODEL_DETAILS_UNAVALIABLE"
  },
  {
    "identifier": "BP_PM_NEW_CAR",
    "source_string": "Add new car",
    "translation": "Add new car",
    "context": " -> BP_PM_NEW_CAR"
  },
  {
    "identifier": "BP_PM_OPERATING_AS",
    "source_string": "Operating as",
    "translation": "Operating as",
    "context": " -> BP_PM_OPERATING_AS"
  },
  {
    "identifier": "BP_PM_PCYA",
    "source_string": "Your account is not assigned to any business group yet. Please contact your administrator to join",
    "translation": "Your account is not assigned to any business group yet. Please contact your administrator to join",
    "context": " -> BP_PM_PCYA"
  },
  {
    "identifier": "BP_PM_SUCCESS_ADD",
    "source_string": "User Added Successfully",
    "translation": "User Added Successfully",
    "context": " -> BP_PM_SUCCESS_ADD"
  },
  {
    "identifier": "BP_PM_SWITCH_PROFILE",
    "source_string": "Switch Profile",
    "translation": "Switch Profile",
    "context": " -> BP_PM_SWITCH_PROFILE"
  },
  {
    "identifier": "BP_PM_TOKEN_FAIL",
    "source_string": "Token validation fail",
    "translation": "Token validation fail",
    "context": " -> BP_PM_TOKEN_FAIL"
  },
  {
    "identifier": "BP_PM_UPDATE_SUCCESS",
    "source_string": "Profile Updated Successfully",
    "translation": "Profile Updated Successfully",
    "context": " -> BP_PM_UPDATE_SUCCESS"
  },
  {
    "identifier": "BP_PM_VIN",
    "source_string": "VIN number",
    "translation": "VIN number",
    "context": " -> BP_PM_VIN"
  },
  {
    "identifier": "BP_PM_VVIN",
    "source_string": "VIN",
    "translation": "VIN",
    "context": " -> BP_PM_VVIN"
  },
  {
    "identifier": "BP_PM_YWLI",
    "source_string": "You will be logged out in",
    "translation": "You will be logged out in",
    "context": " -> BP_PM_YWLI"
  },
  {
    "identifier": "BP_EM_EXERCISES",
    "source_string": "Exercises",
    "translation": "Exercises",
    "context": "BP_EM_EXERCISES"
  },
  {
    "identifier": "BP_EM_P_LL",
    "source_string": "Local language",
    "translation": "Local language",
    "context": "BP_EM_P_LL"
  },
  {
    "identifier": "BP_EM_UPLOAD_EVENT_COVER_IMAGE",
    "source_string": ".jpg .jpeg or .png file to upload event cover image",
    "translation": ".jpg .jpeg or .png file to upload event cover image",
    "context": "BP_EM_UPLOAD_EVENT_COVER_IMAGE"
  },
  {
    "identifier": "BP_EM_UPLOAD_EVENT_LOGO",
    "source_string": ".jpg .jpeg or .png file to upload event logo",
    "translation": ".jpg .jpeg or .png file to upload event logo",
    "context": "BP_EM_UPLOAD_EVENT_LOGO"
  },
  {
    "identifier": "BP_EM_EXERCISE_DRIVE",
    "source_string": "Drive",
    "translation": "Drive",
    "context": "BP_EM_EXERCISE_DRIVE"
  },
  {
    "identifier": "BP_EM_EXERCISE_DRIFT",
    "source_string": "Drift",
    "translation": "Drift",
    "context": "BP_EM_EXERCISE_DRIFT"
  },
  {
    "identifier": "BP_EM_EXERCISE_RACETAXI",
    "source_string": "Race taxi",
    "translation": "Race taxi",
    "context": "BP_EM_EXERCISE_RACETAXI"
  },
  {
    "identifier": "BP_EM_EXERCISE_DRIFTTAXI",
    "source_string": "Drift taxi",
    "translation": "Drift taxi",
    "context": "BP_EM_EXERCISE_DRIFTTAXI"
  },
  {
    "identifier": "BP_LM_ALL_LANGUAGES_LBL",
    "source_string": "All languages",
    "translation": "All languages",
    "context": "BP_LM_ALL_LANGUAGES_LBL"
  },
  {
    "identifier": "BP_UPLOAD_COMPLETE_HEADER",
    "source_string": "Upload complete",
    "translation": "Upload complete",
    "context": "BP_UPLOAD_COMPLETE_HEADER"
  },
  {
    "identifier": "BP_REDIRECTING_NEXT_STEPS_MSG",
    "source_string": "Redirecting you to the next step…",
    "translation": "Redirecting you to the next step…",
    "context": "BP_REDIRECTING_NEXT_STEPS_MSG"
  },
  {
    "identifier": "BP_LM_PERMANENT_NEW",
    "source_string": "Permanent",
    "translation": "Permanent",
    "context": "BP_LM_PERMANENT_NEW"
  },
  {
    "identifier": "BP_LM_TEMPORARY_NEW",
    "source_string": "Temporary",
    "translation": "Temporary",
    "context": "BP_LM_TEMPORARY_NEW"
  },
  {
    "identifier": "BP_EM_DOWNLOAD_SELF_REG_QR",
    "source_string": "Download Self registration QR code",
    "translation": "Download Self registration QR code",
    "context": "BP_EM_DOWNLOAD_SELF_REG_QR"
  },
  {
    "identifier": "BP_EM_DOWNLOAD_QR_CODE_TEXT",
    "source_string": "Use this QR code to let participant register himself. After scanning done close this window and refresh the page.",
    "translation": "Use this QR code to let participant register himself. After scanning done close this window and refresh the page.",
    "context": "BP_EM_DOWNLOAD_QR_CODE_TEXT"
  },
  {
    "identifier": "BP_EM_SELF_REG_QR",
    "source_string": "Self registration QR code",
    "translation": "Self registration QR code",
    "context": "BP_EM_SELF_REG_QR"
  },
  {
    "identifier": "BP_EM_DRIFT_DOWNLOAD_TEMPLATE",
    "source_string": "Download template",
    "translation": "Download template",
    "context": "BP_EM_DRIFT_DOWNLOAD_TEMPLATE"
  },
  {
    "identifier": "BP_EM_EVENT_TERMS_AND_CONDITIONS",
    "source_string": "Event-specific terms of use",
    "translation": "Event-specific terms of use",
    "context": "BP_EM_EVENT_TERMS_AND_CONDITIONS"
  },
  {
    "identifier": "BP_EM_CLICK_TEXT",
    "source_string": "Click",
    "translation": "Click",
    "context": "BP_EM_CLICK_TEXT"
  },
  {
    "identifier": "BP_EM_EVENT_UPLOAD_TERMS_AND_CONDITIONS",
    "source_string": "to upload event specific terms of use.",
    "translation": "to upload event specific terms of use.",
    "context": "BP_EM_EVENT_UPLOAD_TERMS_AND_CONDITIONS"
  },
  {
    "identifier": "BP_EM_UPLOAD_EVENT_TERMS_TEXT",
    "source_string": "Upload event terms of use",
    "translation": "Upload event terms of use",
    "context": "BP_EM_UPLOAD_EVENT_TERMS_TEXT"
  },
  {
    "identifier": "BP_EM_LANGUAGE_TEXT",
    "source_string": "Language",
    "translation": "Language",
    "context": "BP_EM_LANGUAGE_TEXT"
  },
  {
    "identifier": "BP_EM_EN_TEXT",
    "source_string": "English (EN)",
    "translation": "English (EN)",
    "context": "BP_EM_EN_TEXT"
  },
  {
    "identifier": "BP_EM_UPLOAD_EN",
    "source_string": "Upload mandatory for English (EN)",
    "translation": "Upload mandatory for English (EN)",
    "context": "BP_EM_UPLOAD_EN"
  },
  {
    "identifier": "BP_EM_OTHER_LANGUAGE_TEXT",
    "source_string": "Other Languages",
    "translation": "Other Languages",
    "context": "BP_EM_OTHER_LANGUAGE_TEXT"
  },
  {
    "identifier": "BP_EM_NO_UPLOAD_FILE",
    "source_string": "No files uploaded",
    "translation": "No files uploaded",
    "context": "BP_EM_NO_UPLOAD_FILE"
  },
  {
    "identifier": "BP_EM_REMOVE",
    "source_string": "Remove",
    "translation": "Remove",
    "context": "BP_EM_REMOVE"
  },
  {
    "identifier": "BP_EM_EVENT_TERMS_AND_CONDITIONS",
    "source_string": "Event-specific terms of use",
    "translation": "Event-specific terms of use",
    "context": " -> BP_EM_EVENT_TERMS_AND_CONDITIONS"
  },
  {
    "identifier": "BP_EM_EVENT_TERMS_AND_CONDITIONS",
    "source_string": "Event-specific terms of use",
    "translation": "Event-specific terms of use",
    "context": " -> BP_EM_EVENT_TERMS_AND_CONDITIONS"
  },
  {
    "identifier": "BP_EM_EVENT_FILES_ATTACHED",
    "source_string": "Files attached",
    "translation": "Files attached",
    "context": " -> BP_EM_EVENT_FILES_ATTACHED"
  },
  {
    "identifier": "BP_EM_EVENT_UPLOAD_TERMS_AND_CONDITIONS",
    "source_string": "to upload event specific terms of use.",
    "translation": "to upload event specific terms of use.",
    "context": " -> BP_EM_EVENT_UPLOAD_TERMS_AND_CONDITIONS"
  },
  {
    "identifier": "BP_EM_EVENT_FILE_ATTACHED",
    "source_string": "File attached",
    "translation": "File attached",
    "context": " -> BP_EM_EVENT_FILE_ATTACHED"
  },
  {
    "identifier": "BP_EM_EVENT_FILE_UPLOAD_ERROR",
    "source_string": "File size exceeds 6 MB limit",
    "translation": "File size exceeds 6 MB limit",
    "context": " -> BP_EM_EVENT_FILE_UPLOAD_ERROR"
  },
  {
    "identifier": "BP_EM_ENGLISH_UPLOAD_IMP_INFO",
    "source_string": "English is mandatory until other languages are available",
    "translation": "English is mandatory until other languages are available",
    "context": " -> BP_EM_ENGLISH_UPLOAD_IMP_INFO"
  },
  {
    "identifier": "BP_EM_UPLOAD_IMP_INFO",
    "source_string": "Max. file upload is 6MB",
    "translation": "Max. file upload is 6MB",
    "context": " -> BP_EM_UPLOAD_IMP_INFO"
  },
  {
    "identifier": "BP_EM_SEARCH",
    "source_string": "Search",
    "translation": "Search",
    "context": " -> BP_EM_SEARCH"
  },
  {
    "identifier": "BP_EM_GPX_FILE_UPLOAD",
    "source_string": "Upload .gpx",
    "translation": "Upload .gpx",
    "context": " -> BP_EM_GPX_FILE_UPLOAD"
  },
  {
    "identifier": "BP_EM_GPX_FILE_UPLOAD_MSG",
    "source_string": "To set a new track on this circuit, click on the new track.",
    "translation": "To set a new track on this circuit, click on the new track.",
    "context": " -> BP_EM_GPX_FILE_UPLOAD_MSG"
  },
  {
    "identifier": "BP_LM_CIRCUIT_LBL",
    "source_string": "Circuit",
    "translation": "Circuit",
    "context": " -> BP_LM_CIRCUIT_LBL"
  },
  {
    "identifier": "BP_LM_OFFROADPARK_LBL",
    "source_string": "Park",
    "translation": "Park",
    "context": " -> BP_LM_OFFROADPARK_LBL"
  },
  {
    "identifier": "BP_LM_OFFROADTRAIL_LBL",
    "source_string": "Trail",
    "translation": "Trail",
    "context": " -> BP_LM_OFFROADTRAIL_LBL"
  },
  {
    "identifier": "BP_EM_SELECTED",
    "source_string": "Selected",
    "translation": "Selected",
    "context": " -> BP_EM_SELECTED"
  },
  {
    "identifier": "BP_EM_SELECT_LAYOUT_FOR_EXERCISE",
    "source_string": "Select layout for this exercise",
    "translation": "Select layout for this exercise",
    "context": " -> BP_EM_SELECT_LAYOUT_FOR_EXERCISE"
  },
  {
    "identifier": "BP_EM_NSR",
    "source_string": "No results found.",
    "translation": "No results found.",
    "context": " -> BP_EM_NSR"
  },
  {
    "identifier": "BP_LM_GEOFENCE_NAME",
    "source_string": "Enter geofence name*",
    "translation": "Enter geofence name*",
    "context": " -> BP_LM_GEOFENCE_NAME"
  },
  {
    "identifier": "BP_LM_CONTACT_NAME",
    "source_string": "Contact",
    "translation": "Contact",
    "context": " -> BP_LM_CONTACT_NAME"
  },
  {
    "identifier": "BP_EM_REMOVE_PENALTIES_SUB_MSG",
    "source_string": "Add and remove penalties for all participants",
    "translation": "Add and remove penalties for all participants",
    "context": " -> BP_EM_REMOVE_PENALTIES_SUB_MSG"
  }
]
